<template>
  <div>
    <div class="top-panel h50 w100vw box-border pr24 pl27 position-relative d-flex align-items-center">
<!--      <p class="fz20 fw500 text-dark"></p>-->
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center" v-for="(link, i) in getPathSection" :key="i">
          <router-link :to="link.to"  class="fz20 fw500 text-dark" >{{link.name}}</router-link>
          <span v-if="i !== getPathSection.length-1" class="mr4 ml4 w-max h-max d-flex align-items-center justify-center"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.29924 6.40039L5.18326 9.7027C4.91614 9.97456 4.48367 9.9741 4.217 9.70129C3.95053 9.42852 3.95122 8.98664 4.21837 8.71457L6.84906 5.90641L4.21837 3.18915C3.95125 2.91704 3.95057 2.47545 4.217 2.20264C4.35068 2.06588 4.52581 1.9975 4.70094 1.9975C4.87562 1.9975 5.05006 2.06542 5.1835 2.20123L8.29924 5.41247C8.42789 5.54318 8.50009 5.72107 8.50009 5.90641C8.50009 6.09175 8.42769 6.26943 8.29924 6.40039Z" fill="#2C2C2C"/>
              </svg></span>
        </div>

      </div>
      <router-link :to="getLinkToArchive" class="d-flex align-items-center fz13 text-dark ml-auto" >
        <svg v-on:click="clickArchiveLink" class="pr4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.12 9.96H19.72L18.76 19.24H5.96L5 9.96H6.76M18.12 9.96L18.6 7.4H16.52M18.12 9.96H6.76M6.76 9.96L6.12 7.4H8.2M8.2 7.4L7.72 5H17L16.52 7.4M8.2 7.4H16.52M9.96 13.32H14.76" stroke="#2C2C2C" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span v-on:click="clickArchiveLink">Archive</span>
      </router-link>
    </div>
    <div class="content d-flex align-items-stretch">
      <div class="w288 pt8 pl16 overflow-y-auto">
        <div class="wrap-router">
          <router-link :to="{name: 'Folders - My files'}" :class="{'active': $route.path.indexOf('folders/my-files') >= 0}" class="h36 w100Proc border-radius-4 fz16 text-dark fw500 d-flex align-items-center p8 box-border">
            <svg v-on:click="(e)=>clickArrow(e, $route.path.indexOf('folders/my-files') >= 0)" :class="{'rotate-180': $route.path.indexOf('folders/my-files') >= 0 && isOpenLeft}" class="mr8" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.27557 4.39844C9.54284 4.39844 9.67669 4.72158 9.4877 4.91057L6.21196 8.18631C6.0948 8.30346 5.90485 8.30346 5.78769 8.18631L2.51197 4.91057C2.32298 4.72158 2.45683 4.39844 2.7241 4.39844L9.27557 4.39844Z" fill="#9AA3B0"/>
            </svg>
            <svg class="mr8" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.9636 8.86314C18.6984 8.4256 18.2299 8.16406 17.7102 8.16406H6.13968C5.56613 8.16406 5.04449 8.49494 4.81035 9.00726L1.75 15.574C1.86554 16.0549 2.30438 16.4141 2.82709 16.4141H15.1373C15.6636 16.4141 16.1447 16.1095 16.3797 15.6275L19.0249 10.2016C19.2338 9.77227 19.2106 9.27194 18.9636 8.86314Z" fill="#9AA3B0"/>
              <path d="M4.21285 8.2331C4.44631 7.70762 4.96718 7.36801 5.53988 7.36801H16.4167V5.90475C16.4167 5.30156 15.9329 4.81073 15.3382 4.81073H8.9961C8.9868 4.81073 8.98042 4.80822 8.97803 4.8064L7.84287 3.137C7.64183 2.84086 7.30978 2.66406 6.955 2.66406H2.82868C2.2338 2.66406 1.75 3.15489 1.75 3.75808V13.6641L4.21285 8.2331Z" fill="#9AA3B0"/>
            </svg>
            My Files
          </router-link>
          <template v-if="$route.path.indexOf('folders/my-files') >= 0 && isOpenLeft">
            <folders-drop :sequenceOfLinkNestings="getSequenceOfLinkNestings" :activeFolder="getActiveFolder" :link_active="true" @linkTo="linkTo" class="pl24" v-for="(item, i) in foldersList" :key="i" :item="item"></folders-drop>
          </template>
        </div>

        <div class="wrap-router">
          <router-link :to="{name: 'Folders - Shared with me'}" :class="{'active': $route.path.indexOf('folders/shared-with-me') >= 0}" class="h36 w100Proc border-radius-4 fz16 text-dark fw500 d-flex align-items-center mt4 p8 box-border p8 box-border">
            <svg class="mr8 opacity-0" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.27557 4.39844C9.54284 4.39844 9.67669 4.72158 9.4877 4.91057L6.21196 8.18631C6.0948 8.30346 5.90485 8.30346 5.78769 8.18631L2.51197 4.91057C2.32298 4.72158 2.45683 4.39844 2.7241 4.39844L9.27557 4.39844Z" fill="#9AA3B0"/>
            </svg>
            <svg class="mr8" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.95631 5.82483C9.95631 7.40994 8.6716 9.58073 7.0846 9.58073C5.49949 9.58073 4.21289 7.40994 4.21289 5.82483C4.21289 4.23973 5.4976 2.95312 7.0846 2.95312C8.66971 2.95312 9.95631 4.23784 9.95631 5.82483Z" fill="#9AA3B0"/>
              <path d="M9.62556 5.81675C9.62556 5.88476 9.62367 5.95278 9.618 6.0189C9.61611 6.05291 9.61233 6.0888 9.61044 6.12281C9.60856 6.1417 9.60667 6.1606 9.60478 6.18138C9.60289 6.20405 9.601 6.27773 9.60478 6.18705C9.59722 6.33252 9.55377 6.48555 9.51787 6.62536C9.48008 6.77461 9.43474 6.92387 9.38184 7.06745C9.35539 7.13924 9.32705 7.21104 9.29871 7.28094C9.32894 7.20348 9.2836 7.31306 9.27604 7.33195C9.25904 7.37163 9.24015 7.40941 9.22125 7.44909C9.08333 7.73626 8.91708 8.0102 8.72437 8.26526C8.76782 8.20858 8.71492 8.27659 8.69792 8.29737C8.67147 8.32949 8.64502 8.36161 8.61857 8.39373C8.56945 8.45041 8.52033 8.50331 8.46932 8.55621C8.41831 8.60911 8.36541 8.65823 8.31251 8.70735C8.28228 8.7338 8.25205 8.76025 8.22182 8.7867C8.20293 8.8037 8.10658 8.8755 8.17837 8.8226C8.06312 8.90572 7.94599 8.98507 7.81941 9.05309C7.78918 9.0682 7.75895 9.08332 7.72872 9.09843C7.71549 9.1041 7.70227 9.11166 7.68716 9.11732C7.61914 9.14944 7.74006 9.09843 7.69471 9.11543C7.62859 9.13811 7.56435 9.16456 7.49634 9.18345C7.4321 9.20234 7.36787 9.21746 7.30363 9.22879C7.30741 9.22879 7.26018 9.23446 7.26018 9.23635C7.26207 9.22501 7.33953 9.22879 7.27151 9.23446C7.23184 9.23824 7.19027 9.24202 7.1506 9.24391C7.08825 9.24579 7.02591 9.24579 6.96167 9.24013C6.95222 9.24013 6.8691 9.22312 6.86343 9.23068C6.87287 9.21934 6.93522 9.24202 6.8861 9.23257C6.86532 9.22879 6.84265 9.22501 6.82186 9.22123C6.75763 9.20801 6.69339 9.19101 6.63105 9.17211C6.59515 9.16078 6.56114 9.14944 6.52714 9.13622C6.51391 9.13055 6.4988 9.12488 6.48557 9.1211C6.42323 9.09843 6.54792 9.15133 6.48179 9.11921C6.35521 9.05876 6.23241 8.99263 6.11527 8.91328C6.08693 8.89439 6.05859 8.87361 6.03025 8.85282C6.01703 8.84338 6.00569 8.83393 5.99247 8.82448C6.05293 8.86983 6.01703 8.84338 6.0038 8.83204C5.94146 8.78103 5.881 8.73002 5.82243 8.67523C5.71097 8.57132 5.60706 8.46174 5.5107 8.3465C5.48614 8.31816 5.46347 8.28793 5.43891 8.25959C5.40112 8.21236 5.43702 8.2577 5.44458 8.26715C5.43135 8.25014 5.42002 8.23314 5.40679 8.21614C5.35956 8.1519 5.31233 8.08578 5.26887 8.01776C5.18008 7.88173 5.09695 7.74193 5.02138 7.59834C4.98548 7.53033 4.95147 7.46042 4.91936 7.39052C4.90424 7.36029 4.89102 7.32817 4.87779 7.29794C4.8759 7.29606 4.84379 7.21859 4.86457 7.26772C4.88346 7.31306 4.85512 7.24505 4.85134 7.2356C4.79089 7.08635 4.73799 6.9352 4.69453 6.78217C4.65297 6.6367 4.61707 6.48933 4.59062 6.34008C4.58495 6.30418 4.57929 6.27018 4.57362 6.23428C4.57173 6.21916 4.56795 6.20216 4.56606 6.18705C4.56984 6.27206 4.56984 6.21539 4.56795 6.19271C4.56039 6.11903 4.55284 6.04724 4.54906 5.97356C4.5415 5.81675 4.54528 5.65805 4.56228 5.50124C4.56417 5.48423 4.56606 5.46723 4.56795 5.45023C4.5585 5.5258 4.56417 5.47857 4.56606 5.46156C4.57362 5.42378 4.57929 5.38599 4.58684 5.34821C4.60196 5.26886 4.62085 5.1914 4.64352 5.11393C4.6643 5.04214 4.68886 4.96846 4.71531 4.89856C4.72098 4.88155 4.77388 4.75875 4.73799 4.8381C4.75499 4.80031 4.77199 4.76253 4.79089 4.72474C4.8589 4.58682 4.93636 4.45646 5.02516 4.32988C5.04594 4.29965 5.06861 4.26943 5.09128 4.24109C5.04027 4.3091 5.11206 4.21842 5.12529 4.20141C5.1763 4.14095 5.22731 4.08428 5.28399 4.02949C5.33689 3.97659 5.38979 3.92747 5.44647 3.87834C5.47481 3.85378 5.50503 3.833 5.53148 3.80655C5.56738 3.77254 5.46725 3.85189 5.53337 3.80466C5.55416 3.78955 5.57305 3.77443 5.59383 3.76121C5.71474 3.6743 5.84322 3.59873 5.97547 3.53261C6.01325 3.51371 6.05104 3.49671 6.08882 3.47971C6.10394 3.47215 6.14739 3.45515 6.07938 3.48348C6.09449 3.47782 6.1096 3.47026 6.12661 3.46459C6.20407 3.43436 6.28342 3.40602 6.36466 3.38335C6.43834 3.36257 6.51202 3.34368 6.5857 3.32667C6.61971 3.31912 6.65183 3.31345 6.68584 3.30778C6.70662 3.304 6.7274 3.30211 6.75007 3.29833C6.77463 3.29456 6.76707 3.29645 6.72551 3.30211C6.73874 3.30022 6.75196 3.29833 6.7633 3.29833C6.92389 3.27944 7.08636 3.27566 7.24884 3.28322C7.28852 3.28511 7.3263 3.28889 7.36598 3.29267C7.38676 3.29456 7.50578 3.31345 7.41888 3.29833C7.49823 3.31156 7.57947 3.32478 7.65882 3.34368C7.80996 3.37957 7.95921 3.42681 8.1028 3.48726C8.01967 3.45326 8.13303 3.50238 8.15003 3.50993C8.18404 3.52505 8.21804 3.54205 8.25016 3.55906C8.32384 3.59684 8.39564 3.63841 8.46554 3.68375C8.52789 3.72342 8.58834 3.76688 8.6488 3.81033C8.66202 3.81978 8.69603 3.85 8.64124 3.80466C8.65447 3.816 8.66769 3.82544 8.67903 3.83489C8.71115 3.86134 8.74137 3.88779 8.77349 3.91424C8.89063 4.01815 8.99454 4.1334 9.09467 4.25242C9.13246 4.29776 9.09467 4.25242 9.089 4.24298C9.09845 4.2562 9.10978 4.26943 9.11923 4.28265C9.14379 4.31666 9.16835 4.34878 9.19102 4.38278C9.23448 4.44702 9.27604 4.51503 9.31383 4.58305C9.34972 4.64728 9.38373 4.7153 9.41585 4.78142C9.42529 4.80031 9.43285 4.81921 9.4423 4.8381C9.43852 4.82865 9.41585 4.77197 9.43852 4.82865C9.45363 4.86833 9.46875 4.90611 9.48386 4.94579C9.53676 5.09693 9.57833 5.25374 9.60667 5.41244C9.61233 5.44267 9.62367 5.52769 9.61422 5.45212C9.618 5.49179 9.62367 5.52958 9.62745 5.56925C9.62178 5.6486 9.62367 5.73362 9.62556 5.81675C9.62556 5.99056 9.7767 6.15493 9.95618 6.14737C10.1338 6.13981 10.2868 6.0019 10.2868 5.81675C10.283 5.07804 10.028 4.37711 9.57077 3.80088C9.14001 3.26055 8.51466 2.86569 7.84208 2.7051C7.11659 2.53129 6.35332 2.61819 5.68074 2.93937C5.06105 3.23599 4.53583 3.75365 4.22977 4.36767C3.90103 5.02703 3.82357 5.74684 3.94449 6.46855C4.05595 7.13925 4.3299 7.79671 4.70587 8.36161C5.07239 8.91517 5.56171 9.43094 6.17951 9.70111C6.48557 9.83525 6.81431 9.91649 7.15249 9.90326C7.49067 9.89004 7.81374 9.79558 8.11413 9.64443C8.7187 9.34026 9.19669 8.80181 9.5481 8.23314C9.91084 7.64557 10.1602 6.98055 10.2509 6.29474C10.2717 6.13604 10.2868 5.97734 10.2868 5.81675C10.2868 5.64293 10.1338 5.47857 9.95618 5.48612C9.7767 5.49368 9.62556 5.6316 9.62556 5.81675Z" fill="#9AA3B0"/>
              <path d="M12.8426 13.5488V15.8538H1.33691V13.5488C1.33691 11.9203 2.64997 10.6016 4.27664 10.6016H4.96623L7.09356 13.3165L9.202 10.6016H9.89158C11.5201 10.6016 12.8426 11.9203 12.8426 13.5488Z" fill="#9AA3B0"/>
              <path d="M12.5095 13.5515C12.5095 14.2203 12.5095 14.891 12.5095 15.5598C12.5095 15.6561 12.5095 15.7506 12.5095 15.8469C12.6191 15.7374 12.7306 15.6259 12.8401 15.5163C12.4566 15.5163 12.0731 15.5163 11.6896 15.5163C10.7751 15.5163 9.85884 15.5163 8.94443 15.5163C7.8392 15.5163 6.73208 15.5163 5.62685 15.5163C4.66521 15.5163 3.70356 15.5163 2.74381 15.5163C2.28093 15.5163 1.81428 15.4974 1.35141 15.5163C1.34574 15.5163 1.33818 15.5163 1.33251 15.5163C1.44209 15.6259 1.55356 15.7374 1.66314 15.8469C1.66314 15.1101 1.66314 14.3714 1.66314 13.6346C1.66314 13.6062 1.66314 13.5798 1.66314 13.5515C1.66314 13.4721 1.66692 13.3928 1.67258 13.3134C1.67636 13.27 1.68203 13.2265 1.68581 13.183C1.67636 13.2718 1.69526 13.1283 1.69903 13.1037C1.73115 12.9318 1.77649 12.7636 1.83884 12.6011C1.8464 12.5785 1.89741 12.4613 1.86151 12.5407C1.87663 12.5067 1.89174 12.4727 1.90874 12.4387C1.94653 12.3593 1.98809 12.2837 2.03344 12.2082C2.075 12.1364 2.12223 12.0684 2.16947 12.0004C2.17891 11.9871 2.18836 11.9739 2.1978 11.9607C2.24504 11.8946 2.16569 11.9966 2.19969 11.9588C2.22992 11.9248 2.25637 11.8889 2.2866 11.853C2.39807 11.7245 2.51898 11.6074 2.64934 11.4997C2.66446 11.4865 2.68146 11.4732 2.69846 11.4619C2.64179 11.5073 2.67768 11.477 2.69091 11.4676C2.72491 11.443 2.75703 11.4185 2.79104 11.3958C2.86661 11.3448 2.94407 11.2975 3.02342 11.2522C3.08955 11.2163 3.15567 11.1823 3.22368 11.1521C3.23691 11.1464 3.31626 11.1124 3.23691 11.1445C3.25202 11.1388 3.26714 11.1313 3.28414 11.1256C3.33137 11.1067 3.37861 11.0897 3.42584 11.0727C3.51463 11.0425 3.60343 11.0179 3.69412 10.9971C3.74324 10.9858 3.79425 10.9745 3.84526 10.9669C3.86226 10.9631 3.87927 10.9612 3.89627 10.9575C3.91327 10.9556 3.93028 10.9518 3.94728 10.9499C3.90572 10.9556 3.89816 10.9556 3.92461 10.9537C4.05875 10.9405 4.19289 10.9329 4.32891 10.9329C4.5424 10.9329 4.75589 10.9329 4.96749 10.9329C4.89003 10.9008 4.81257 10.8687 4.73322 10.8366C4.97316 11.1426 5.2131 11.4487 5.45304 11.7547C5.83278 12.2403 6.21442 12.7258 6.59416 13.2114C6.68296 13.3247 6.77176 13.4362 6.85866 13.5496C6.96068 13.678 7.22518 13.678 7.32532 13.5496C7.56336 13.2435 7.79953 12.9374 8.03758 12.6333C8.41543 12.1458 8.79518 11.6584 9.17303 11.171C9.25994 11.0595 9.34685 10.948 9.43375 10.8347C9.35629 10.8668 9.27883 10.8989 9.19948 10.931C9.41108 10.931 9.62268 10.931 9.83428 10.931C9.96653 10.931 10.0988 10.9386 10.231 10.9499C10.3198 10.9594 10.1592 10.9367 10.2461 10.9518C10.2669 10.9556 10.2896 10.9594 10.3104 10.9631C10.3576 10.9707 10.403 10.9801 10.4483 10.9915C10.5484 11.0141 10.6467 11.0406 10.743 11.0746C10.7827 11.0878 10.8224 11.1029 10.8621 11.1181C10.8847 11.1275 10.9093 11.137 10.932 11.1464C10.8621 11.1181 10.9168 11.1388 10.9338 11.1483C11.0208 11.1899 11.1058 11.2314 11.1889 11.2786C11.2682 11.324 11.3457 11.3731 11.4194 11.426C11.4402 11.4411 11.4591 11.4543 11.4798 11.4695C11.546 11.5167 11.444 11.4373 11.4817 11.4714C11.5214 11.5073 11.5649 11.5394 11.6045 11.5753C11.7406 11.6962 11.8653 11.8284 11.9767 11.9701C11.9238 11.904 11.9767 11.9701 11.9843 11.9815C11.9994 12.0022 12.0126 12.0211 12.0277 12.0419C12.0504 12.0759 12.075 12.1099 12.0958 12.1458C12.1487 12.2308 12.1978 12.3178 12.2431 12.4065C12.2658 12.4519 12.2866 12.4972 12.3074 12.5426C12.2715 12.4651 12.3074 12.5426 12.313 12.5558C12.3262 12.5879 12.3376 12.6181 12.3489 12.6503C12.3829 12.7466 12.4113 12.843 12.4358 12.9412C12.449 12.996 12.4604 13.0489 12.4698 13.1037C12.4736 13.1245 12.4774 13.1453 12.4812 13.1679C12.4831 13.1849 12.4868 13.2019 12.4887 13.2189C12.4831 13.1736 12.4831 13.1698 12.4868 13.2076C12.5019 13.3247 12.5095 13.4381 12.5095 13.5515C12.5095 13.7253 12.6606 13.8896 12.8401 13.8821C13.0177 13.8745 13.1708 13.7366 13.1708 13.5515C13.167 12.6314 12.774 11.7283 12.0844 11.1143C11.7387 10.8063 11.3363 10.5739 10.8979 10.4304C10.5371 10.3113 10.1592 10.2735 9.78138 10.2735C9.63402 10.2735 9.48477 10.2735 9.3374 10.2735C9.20326 10.2735 9.06912 10.266 8.9671 10.3756C8.88019 10.4681 8.80651 10.5815 8.72905 10.6816C8.37198 11.1407 8.0149 11.6017 7.65783 12.0608C7.39711 12.3952 7.11938 12.7221 6.87378 13.0697C6.87 13.0754 6.86433 13.081 6.86055 13.0867C7.01547 13.0867 7.17228 13.0867 7.32721 13.0867C6.97013 12.6314 6.61495 12.1761 6.25787 11.7226C6.01415 11.4128 5.77233 11.1011 5.52861 10.7912C5.44926 10.6892 5.36802 10.5872 5.28867 10.4851C5.24333 10.4285 5.20176 10.3567 5.13375 10.3208C5.0374 10.2698 4.94293 10.2754 4.84091 10.2754C4.74078 10.2754 4.63876 10.2754 4.53862 10.2754C4.3497 10.2754 4.16266 10.2717 3.97562 10.2906C3.33137 10.3567 2.73625 10.5966 2.22803 10.9971C1.74627 11.3769 1.3873 11.8983 1.18137 12.4765C1.03967 12.8713 1 13.287 1 13.7026C1 14.3997 1 15.0969 1 15.7921C1 15.811 1 15.8299 1 15.8488C1 16.0283 1.15114 16.1794 1.33062 16.1794C1.71415 16.1794 2.09767 16.1794 2.4812 16.1794C3.39561 16.1794 4.31191 16.1794 5.22632 16.1794C6.33155 16.1794 7.43867 16.1794 8.5439 16.1794C9.50555 16.1794 10.4672 16.1794 11.4269 16.1794C11.8898 16.1794 12.3565 16.1908 12.8193 16.1794C12.825 16.1794 12.8326 16.1794 12.8382 16.1794C13.0177 16.1794 13.1689 16.0283 13.1689 15.8488C13.1689 15.18 13.1689 14.5093 13.1689 13.8405C13.1689 13.7442 13.1689 13.6497 13.1689 13.5533C13.1689 13.3795 13.0177 13.2152 12.8382 13.2227C12.6606 13.2284 12.5095 13.3663 12.5095 13.5515Z" fill="#9AA3B0"/>
              <path d="M16.4316 7.06151C16.4316 8.29144 15.434 9.97479 14.2041 9.97479C12.9742 9.97479 11.9785 8.29144 11.9785 7.06151C11.9785 5.83159 12.9761 4.83594 14.2041 4.83594C15.4359 4.83405 16.4316 5.83159 16.4316 7.06151Z" fill="#9AA3B0"/>
              <path d="M16.1026 7.06202C16.1026 7.11492 16.1007 7.16782 16.0969 7.22072C16.095 7.24717 16.0931 7.27362 16.0913 7.30196C16.0894 7.31707 16.078 7.41154 16.0856 7.36241C16.0931 7.30951 16.0799 7.40209 16.078 7.41154C16.0743 7.4361 16.0705 7.45877 16.0648 7.48333C16.0535 7.54379 16.0402 7.60235 16.0251 7.66281C15.9968 7.77995 15.9609 7.89519 15.9193 8.01044C15.8986 8.06712 15.8778 8.12191 15.8551 8.1767C15.8759 8.12191 15.8608 8.16347 15.8475 8.19181C15.8343 8.22393 15.8192 8.25416 15.8041 8.28438C15.6964 8.50921 15.5679 8.71703 15.4206 8.91729C15.4546 8.87195 15.43 8.90596 15.4111 8.92863C15.3922 8.9513 15.3733 8.97397 15.3544 8.99475C15.3148 9.04199 15.2732 9.08733 15.2297 9.13078C15.1901 9.17046 15.1504 9.21013 15.1069 9.24792C15.0862 9.26681 15.0654 9.2857 15.0446 9.30271C15.0314 9.31404 14.9596 9.37072 14.9955 9.34427C15.0333 9.31593 14.9615 9.36883 14.9539 9.3745C14.935 9.38772 14.9161 9.40095 14.8972 9.41418C14.85 9.44629 14.8009 9.47463 14.7499 9.50108C14.7272 9.51431 14.7026 9.52564 14.68 9.53698C14.6648 9.54454 14.5931 9.57099 14.6384 9.55587C14.6837 9.54265 14.6101 9.56532 14.5949 9.57099C14.5666 9.58043 14.5383 9.58988 14.5118 9.59743C14.4627 9.61255 14.4117 9.62389 14.3626 9.63333C14.3512 9.63522 14.3399 9.63711 14.3304 9.639C14.287 9.64845 14.3985 9.63333 14.3531 9.63522C14.3248 9.63711 14.2946 9.64089 14.2643 9.64089C14.2171 9.64278 14.168 9.64278 14.1207 9.639C14.1056 9.63711 14.0924 9.63711 14.0773 9.63522C14.0527 9.62011 14.0527 9.63333 14.0773 9.63522C14.1113 9.656 14.0886 9.63711 14.0678 9.63333C14.0527 9.63144 14.0395 9.62766 14.0244 9.62577C13.9734 9.61633 13.9243 9.6031 13.8751 9.58799C13.8506 9.58043 13.826 9.57287 13.8014 9.56343C13.792 9.55965 13.7807 9.55398 13.7712 9.55209C13.7315 9.53887 13.8336 9.58232 13.7788 9.55587C13.6824 9.51053 13.5898 9.45952 13.5011 9.40095C13.4784 9.38584 13.4557 9.37072 13.4349 9.35372C13.3669 9.30649 13.4633 9.37828 13.4179 9.34049C13.3726 9.30271 13.3272 9.26303 13.2819 9.22336C13.195 9.14212 13.1138 9.05521 13.0382 8.96453C13.0231 8.94563 13.0061 8.92674 12.9909 8.90596C12.9532 8.85873 12.9909 8.90407 12.9966 8.91352C12.9891 8.90407 12.9815 8.89273 12.9739 8.88329C12.9362 8.83228 12.9003 8.78127 12.8644 8.72648C12.7964 8.62257 12.734 8.51677 12.6754 8.40719C12.649 8.35807 12.6244 8.30895 12.6018 8.25793C12.5885 8.23148 12.5772 8.20315 12.564 8.1767C12.5602 8.16725 12.5375 8.11624 12.5545 8.1578C12.5715 8.19748 12.5489 8.14647 12.547 8.13891C12.5016 8.02555 12.4619 7.91031 12.4279 7.79317C12.3958 7.68359 12.3694 7.57212 12.3486 7.45877C12.3429 7.43043 12.3391 7.40398 12.3354 7.37564C12.3221 7.29062 12.3391 7.41909 12.3335 7.35864C12.3278 7.30196 12.3221 7.24339 12.3184 7.18671C12.3127 7.0658 12.3165 6.94677 12.3278 6.82775C12.3335 6.76162 12.3184 6.87876 12.3297 6.81263C12.3354 6.78241 12.3391 6.75407 12.3448 6.72384C12.3561 6.66149 12.3713 6.59914 12.3883 6.53869C12.4053 6.48201 12.4223 6.42722 12.4431 6.37054C12.4468 6.35732 12.4827 6.27608 12.4638 6.31764C12.4468 6.35732 12.4638 6.31764 12.4676 6.31197C12.4771 6.29308 12.4846 6.27419 12.4941 6.2553C12.5451 6.15138 12.6036 6.05125 12.6698 5.95679C12.6868 5.93412 12.7038 5.90956 12.7208 5.88689C12.6811 5.93979 12.7208 5.88877 12.7378 5.86799C12.7775 5.82076 12.819 5.77542 12.8625 5.73196C12.9022 5.6904 12.9456 5.65261 12.9891 5.61483C13.0079 5.59782 13.0268 5.58271 13.0457 5.5676C13.0911 5.52981 13.0457 5.5676 13.0363 5.57326C13.0495 5.56382 13.0627 5.55437 13.076 5.54304C13.1723 5.47313 13.2762 5.41079 13.382 5.35789C13.4085 5.34466 13.4349 5.33333 13.4614 5.3201C13.5143 5.29365 13.4085 5.33899 13.4859 5.30877C13.5445 5.28609 13.6031 5.26531 13.6635 5.24642C13.7164 5.2313 13.7693 5.21619 13.8241 5.20485C13.8525 5.19919 13.8827 5.19352 13.911 5.18785C13.9375 5.18218 14.0263 5.17463 13.9507 5.18029C14.0773 5.17085 14.2039 5.1614 14.3304 5.16896C14.3607 5.17085 14.3909 5.17274 14.4211 5.17652C14.4344 5.1784 14.4476 5.18029 14.4608 5.18029C14.5099 5.18407 14.4022 5.17085 14.4495 5.1784C14.5118 5.18785 14.5761 5.19919 14.6384 5.2143C14.7536 5.24075 14.8651 5.27854 14.9728 5.32199C14.9105 5.29743 14.9709 5.32199 14.9955 5.33333C15.0219 5.34655 15.0484 5.35789 15.0729 5.373C15.1277 5.40134 15.1806 5.43346 15.2335 5.46558C15.2789 5.49391 15.3223 5.52414 15.3658 5.55626C15.4149 5.59027 15.3658 5.55626 15.3582 5.5487C15.3677 5.55626 15.3771 5.56382 15.3866 5.57138C15.4111 5.59216 15.4376 5.61294 15.4621 5.63561C15.5509 5.71496 15.6303 5.80187 15.7077 5.89444C15.7455 5.93979 15.6756 5.8491 15.7228 5.91522C15.7399 5.9379 15.7569 5.96246 15.772 5.98513C15.8041 6.03236 15.8343 6.08148 15.8627 6.13249C15.891 6.1835 15.9174 6.23451 15.942 6.28741C15.9496 6.30253 15.9552 6.31764 15.9628 6.33276C15.9609 6.33087 15.942 6.27608 15.9533 6.31197C15.9647 6.34409 15.9779 6.37432 15.9892 6.40644C16.0308 6.52168 16.061 6.64071 16.0837 6.76162C16.0875 6.78618 16.0913 6.81263 16.095 6.83719C16.0818 6.75218 16.095 6.84475 16.0969 6.86553C16.1007 6.92977 16.1026 6.99589 16.1026 7.06202C16.1045 7.23583 16.2537 7.4002 16.4332 7.39264C16.6108 7.38509 16.7657 7.24717 16.7638 7.06202C16.7563 5.90011 15.9477 4.84589 14.8084 4.57572C13.6768 4.30745 12.4544 4.85156 11.9292 5.89822C11.6647 6.42533 11.6023 6.99778 11.6968 7.57401C11.7818 8.09923 11.9972 8.6169 12.2881 9.06088C12.5791 9.50108 12.9683 9.91861 13.4595 10.134C13.7089 10.2436 13.9734 10.3116 14.2492 10.3021C14.525 10.2927 14.7858 10.2171 15.0314 10.0962C15.515 9.85627 15.8967 9.4274 16.1763 8.97397C16.4634 8.5111 16.6599 7.98588 16.7317 7.44743C16.7487 7.31896 16.7601 7.19049 16.762 7.06013C16.762 6.88632 16.6089 6.72195 16.4313 6.7295C16.2537 6.73895 16.1045 6.87687 16.1026 7.06202Z" fill="#9AA3B0"/>
              <path d="M14.2217 14.8588H18.6615V13.0735C18.6615 11.8114 17.6451 10.7969 16.383 10.7969H15.8484L14.2217 12.8505V14.8588Z" fill="#9AA3B0"/>
              <path d="M14.2126 15.1929C14.7133 15.1929 15.2158 15.1929 15.7165 15.1929C16.5157 15.1929 17.3148 15.1929 18.1159 15.1929C18.301 15.1929 18.4843 15.1929 18.6694 15.1929C18.8489 15.1929 19.0001 15.0418 19.0001 14.8623C19.0001 14.2691 19.0019 13.6777 19.0001 13.0845C18.9982 12.4554 18.7715 11.8565 18.3671 11.3766C17.9742 10.908 17.3923 10.5831 16.7858 10.4981C16.561 10.466 16.3418 10.4641 16.117 10.4641C15.947 10.4641 15.7297 10.4319 15.605 10.5736C15.4255 10.7777 15.2649 11.0025 15.0949 11.216C14.8361 11.5428 14.5772 11.8697 14.3184 12.1946C14.2296 12.3061 14.1427 12.4176 14.0539 12.529C13.9746 12.6311 13.8877 12.7218 13.882 12.8616C13.8707 13.1563 13.882 13.4529 13.882 13.7457C13.882 14.0972 13.882 14.4467 13.882 14.7981C13.882 14.8189 13.882 14.8396 13.882 14.8604C13.882 15.0361 14.035 15.2024 14.2126 15.1929C14.3921 15.1854 14.5432 15.0475 14.5432 14.8623C14.5432 14.2785 14.5432 13.6947 14.5432 13.1109C14.5432 13.0278 14.5432 12.9428 14.5432 12.8597C14.5111 12.9371 14.479 13.0146 14.4469 13.0939C14.9249 12.4913 15.4029 11.8886 15.8809 11.284C15.947 11.199 16.015 11.1159 16.0811 11.0308C16.0037 11.063 15.9262 11.0951 15.8468 11.1272C15.9942 11.1272 16.1397 11.1272 16.287 11.1272C16.3532 11.1272 16.4212 11.1272 16.4873 11.1291C16.5232 11.131 16.5572 11.1329 16.5931 11.1366C16.6101 11.1385 16.6271 11.1404 16.6441 11.1423C16.6517 11.1423 16.6951 11.1499 16.6517 11.1423C16.6044 11.1348 16.6611 11.1442 16.6725 11.1461C16.6895 11.148 16.7065 11.1518 16.7235 11.1555C16.7613 11.1631 16.799 11.1707 16.8368 11.1801C16.8935 11.1933 16.9521 11.2103 17.0088 11.2292C17.0409 11.2406 17.073 11.25 17.1032 11.2632C17.1183 11.2689 17.1353 11.2765 17.1504 11.2821C17.1108 11.267 17.1164 11.267 17.1523 11.284C17.2695 11.3388 17.3828 11.3993 17.4886 11.471C17.517 11.4899 17.5434 11.5088 17.5699 11.5277C17.6171 11.5617 17.5283 11.4918 17.5907 11.5447C17.6417 11.5863 17.6908 11.6297 17.738 11.677C17.7815 11.7204 17.8249 11.7639 17.8665 11.8111C17.8892 11.8357 17.9099 11.8621 17.9307 11.8867C17.9421 11.8999 17.9666 11.9358 17.9251 11.8791C17.9345 11.8924 17.9439 11.9056 17.9553 11.9188C18.0327 12.0265 18.1008 12.1417 18.1593 12.2608C18.1726 12.2872 18.1839 12.3137 18.1952 12.3401C18.216 12.3817 18.1763 12.2853 18.1914 12.3307C18.1971 12.3458 18.2028 12.3628 18.2103 12.3779C18.233 12.4403 18.2538 12.5064 18.2727 12.5706C18.2897 12.633 18.3029 12.6953 18.3161 12.7577C18.3199 12.7747 18.3331 12.8861 18.3237 12.7973C18.3275 12.8313 18.3313 12.8672 18.335 12.9012C18.3407 12.9693 18.3426 13.0373 18.3426 13.1072C18.3426 13.4 18.3426 13.6928 18.3426 13.9857C18.3426 14.2785 18.3426 14.5733 18.3426 14.8661C18.4522 14.7565 18.5636 14.645 18.6732 14.5355C18.1726 14.5355 17.67 14.5355 17.1693 14.5355C16.3702 14.5355 15.571 14.5355 14.77 14.5355C14.5848 14.5355 14.4015 14.5355 14.2164 14.5355C14.0426 14.5355 13.8782 14.6866 13.8858 14.8661C13.8914 15.0418 14.0275 15.1929 14.2126 15.1929Z" fill="#9AA3B0"/>
            </svg>
            Shared with me
          </router-link>
        </div>
        <div class="wrap-router">
          <router-link :to="{name: 'Folders - Tasks'}" :class="{'active': $route.path.indexOf('folders/tasks') >= 0}" class="h36 w100Proc border-radius-4 fz16 text-dark fw500 d-flex align-items-center mt4 p8 box-border">
            <svg v-on:click="(e)=>clickArrow(e, $route.path.indexOf('folders/tasks') >= 0)"  :class="{'rotate-180': $route.path.indexOf('folders/tasks') >= 0 && isOpenLeft}" class="mr8" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.27557 4.39844C9.54284 4.39844 9.67669 4.72158 9.4877 4.91057L6.21196 8.18631C6.0948 8.30346 5.90485 8.30346 5.78769 8.18631L2.51197 4.91057C2.32298 4.72158 2.45683 4.39844 2.7241 4.39844L9.27557 4.39844Z" fill="#9AA3B0"/>
            </svg>
            <svg class="mr8" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 2.5C3.84315 2.5 2.5 3.84315 2.5 5.5V14.5C2.5 16.1569 3.84315 17.5 5.5 17.5H14.5C16.1569 17.5 17.5 16.1569 17.5 14.5V5.5C17.5 3.84315 16.1569 2.5 14.5 2.5H5.5ZM13.8908 8.41579C14.1679 8.1079 14.1429 7.63369 13.8351 7.35659C13.5272 7.0795 13.053 7.10446 12.7759 7.41234L9.55469 10.9914L8.03033 9.46707C7.73744 9.17417 7.26256 9.17417 6.96967 9.46707C6.67678 9.75996 6.67678 10.2348 6.96967 10.5277L9.053 12.6111C9.19849 12.7565 9.39737 12.8359 9.60305 12.8305C9.80873 12.8251 10.0032 12.7354 10.1408 12.5825L13.8908 8.41579Z" fill="#9AA3B0"/>
            </svg>
            Tasks
          </router-link>
          <template v-if="$route.path.indexOf('folders/tasks') >= 0 && isOpenLeft">
            <folders-drop @linkTo="linkTo" :sequenceOfLinkNestings="getSequenceOfLinkNestings[i]" :link_active="true" :activeType="getActiveType" :activeObject="getActiveObject" :activeFolder="getActiveFolder" class="pl24" v-for="(item, i) in foldersList" :key="i" :item="item"></folders-drop>
          </template>
        </div>
        <div class="wrap-router">
          <router-link :to="{name: 'Folders - Payments'}" :class="{'active': nameSectionFolders == 'Payments'}" class="h36 w100Proc border-radius-4 fz16 text-dark fw500 d-flex align-items-center mt4 p8 box-border">
            <svg v-on:click="(e)=>clickArrow(e, $route.path.indexOf('folders/payments') >= 0)"  :class="{'rotate-180': $route.path.indexOf('folders/payments') >= 0 && isOpenLeft}"  class="mr8" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.27557 4.39844C9.54284 4.39844 9.67669 4.72158 9.4877 4.91057L6.21196 8.18631C6.0948 8.30346 5.90485 8.30346 5.78769 8.18631L2.51197 4.91057C2.32298 4.72158 2.45683 4.39844 2.7241 4.39844L9.27557 4.39844Z" fill="#9AA3B0"/>
            </svg>
            <svg class="mr8" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15 4.16667H5C4.53976 4.16667 4.16667 4.53976 4.16667 5V15C4.16667 15.4602 4.53976 15.8333 5 15.8333H15C15.4602 15.8333 15.8333 15.4602 15.8333 15V5C15.8333 4.53976 15.4602 4.16667 15 4.16667ZM5 2.5C3.61929 2.5 2.5 3.61929 2.5 5V15C2.5 16.3807 3.61929 17.5 5 17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V5C17.5 3.61929 16.3807 2.5 15 2.5H5Z" fill="#9AA3B0"/>
              <path d="M2.5 5C2.5 3.61929 3.61929 2.5 5 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V8.33333H2.5V5Z" fill="#9AA3B0"/>
              <path d="M5.83333 2.08333C5.83333 1.6231 6.20643 1.25 6.66667 1.25C7.1269 1.25 7.5 1.6231 7.5 2.08333V3.33333C7.5 3.79357 7.1269 4.16667 6.66667 4.16667C6.20643 4.16667 5.83333 3.79357 5.83333 3.33333V2.08333Z" fill="#9AA3B0"/>
              <path d="M12.5 2.08333C12.5 1.6231 12.8731 1.25 13.3333 1.25C13.7936 1.25 14.1667 1.6231 14.1667 2.08333V3.33333C14.1667 3.79357 13.7936 4.16667 13.3333 4.16667C12.8731 4.16667 12.5 3.79357 12.5 3.33333V2.08333Z" fill="#9AA3B0"/>
            </svg>
            Payments
          </router-link>
          <template v-if="$route.path.indexOf('folders/payment') >= 0 && isOpenLeft">
            <folders-drop :sequenceOfLinkNestings="getSequenceOfLinkNestings" @linkTo="linkTo" :link_active="true" :activeType="getActiveType" :activeObject="getActiveObject" :activeFolder="getActiveFolder" class="pl24" v-for="(item, i) in foldersList" :index="i" :key="i" :item="item"></folders-drop>
            <pagination-panel-default :if-active="loadMorePaymentBool" @load-more="loadMorePayment" v-if="nextLinkPaymentLeftList"></pagination-panel-default>
          </template>

        </div>
        <div class="wrap-router">
          <router-link :to="{name: 'Folders - Vessels', params: {vessels_is_archive: false}}" :class="{'active': $route.path.indexOf('folders/vessels') >= 0}" class="h36 w100Proc border-radius-4 fz16 text-dark fw500 d-flex align-items-center mt4 p8 box-border">
            <svg v-on:click="(e)=>clickArrow(e, $route.path.indexOf('folders/vessels') >= 0)"  :class="{'rotate-180': $route.path.indexOf('folders/vessels') >= 0 && isOpenLeft}" class="mr8" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.27557 4.39844C9.54284 4.39844 9.67669 4.72158 9.4877 4.91057L6.21196 8.18631C6.0948 8.30346 5.90485 8.30346 5.78769 8.18631L2.51197 4.91057C2.32298 4.72158 2.45683 4.39844 2.7241 4.39844L9.27557 4.39844Z" fill="#9AA3B0"/>
            </svg>
            <svg class="mr8" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.00008 10.0251L9.76898 7.66197V12.0986C9.76898 12.3189 9.94751 12.4974 10.1677 12.4974C10.388 12.4974 10.5665 12.3189 10.5665 12.0986V7.64757L16.3706 10.0251C16.8709 10.2301 17.1177 10.7955 16.9278 11.3017L15.4804 15.1603H15.3334C14.4067 15.1603 13.4801 14.8069 12.6667 14.1641C11.0401 15.4498 8.96008 15.4498 7.3334 14.1641C6.58474 14.7558 5.74007 15.1023 4.88776 15.1536L3.44285 11.3017C3.25297 10.7955 3.49979 10.2301 4.00008 10.0251ZM5.09189 5.69686C5.09189 5.31027 5.40529 4.99686 5.79189 4.99686H9.06866C9.45526 4.99686 9.76865 5.31027 9.76865 5.69686V6.24441C9.76865 6.54047 9.5824 6.80452 9.30349 6.90384L6.02673 8.07078C5.57096 8.23308 5.09189 7.89515 5.09189 7.41134V5.69686ZM15.2788 7.41134C15.2788 7.89515 14.7997 8.23308 14.3439 8.07078L11.0671 6.90384C10.7882 6.80452 10.602 6.54047 10.602 6.24441V5.69687C10.602 5.31027 10.9154 4.99686 11.302 4.99686H14.5788C14.9654 4.99686 15.2788 5.31027 15.2788 5.69686V7.41134ZM12.9161 3.86353C12.9161 4.02921 12.7818 4.16353 12.6161 4.16353H7.79942C7.63373 4.16353 7.49942 4.02921 7.49942 3.86353V3.20781C7.49942 2.82121 7.81282 2.50781 8.19942 2.50781H12.2161C12.6027 2.50781 12.9161 2.82121 12.9161 3.20781V3.86353Z" fill="#9AA3B0"/>
              <path d="M12.6663 15.25C11.0397 16.5357 8.95966 16.5357 7.33297 15.25C6.51963 15.8929 5.59297 16.2462 4.66632 16.2462H4.12372C3.68702 16.2462 3.333 16.6003 3.33299 17.037V17.037C3.33298 17.4737 3.68701 17.8277 4.12372 17.8277H4.66632C5.58297 17.8277 6.49297 17.5683 7.33297 17.0796C9.01297 18.0533 10.9863 18.0533 12.6663 17.0796C13.5063 17.5645 14.4163 17.8277 15.333 17.8277H15.8756C16.3123 17.8277 16.6663 17.4737 16.6663 17.037V17.037C16.6663 16.6003 16.3123 16.2462 15.8756 16.2462H15.333C14.4063 16.2462 13.4797 15.8929 12.6663 15.25Z" fill="#9AA3B0"/>
            </svg>
            Vessels
          </router-link>
          <template v-if="$route.path.indexOf('folders/vessels') >= 0 && isOpenLeft">
            <folders-drop :sequenceOfLinkNestings="getSequenceOfLinkNestings[i]"  @linkTo="linkTo" :link_active="true" :activeType="getActiveType" :activeObject="getActiveObject" :activeFolder="getActiveFolder" class="pl24" v-for="(item, i) in foldersList" :key="i" :item="item"></folders-drop>
          </template>
        </div>
        <div class="wrap-router">
          <router-link :to="{name: 'Folders - Ports', params: {countries_is_archive: false}}" :class="{'active': $route.path.indexOf('folders/countries') >= 0}" class="h36 w100Proc border-radius-4 fz16 text-dark fw500 d-flex align-items-center mt4 p8 box-border">
            <svg v-on:click="(e)=>clickArrow(e, $route.path.indexOf('folders/countries') >= 0)" :class="{'rotate-180': $route.path.indexOf('folders/countries') >= 0 && isOpenLeft}"  class="mr8" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.27557 4.39844C9.54284 4.39844 9.67669 4.72158 9.4877 4.91057L6.21196 8.18631C6.0948 8.30346 5.90485 8.30346 5.78769 8.18631L2.51197 4.91057C2.32298 4.72158 2.45683 4.39844 2.7241 4.39844L9.27557 4.39844Z" fill="#9AA3B0"/>
            </svg>
            <svg class="mr8" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.9746 14.3779L16.6767 14.5957C17.0559 14.7129 17.4214 14.3763 17.3331 13.988L16.5914 10.712C16.5031 10.3252 16.0295 10.1774 15.737 10.447L13.2713 12.7285C12.9789 12.998 13.0885 13.4823 13.4693 13.6011L14.112 13.8007C13.7282 14.2408 13.2759 14.6185 12.7702 14.917C12.1976 15.2551 11.5686 15.4851 10.9137 15.5947V10.1241H12.4961C13.0002 10.1241 13.4099 9.71446 13.4099 9.21033C13.4099 8.70622 13.0002 8.29653 12.4961 8.29653H10.9137V7.54265C11.9006 7.17104 12.6042 6.21916 12.6042 5.10433C12.6042 3.66814 11.4361 2.5 9.99989 2.5C8.5637 2.5 7.39556 3.66814 7.39556 5.10433C7.39556 6.21916 8.09919 7.17256 9.08609 7.54265V8.29653H7.5037C6.99958 8.29653 6.5899 8.70622 6.5899 9.21033C6.5899 9.71446 6.99958 10.1241 7.5037 10.1241H9.08609V15.5947C8.43272 15.4836 7.8022 15.2551 7.22956 14.917C6.72544 14.617 6.27161 14.2393 5.88779 13.7991L6.5305 13.5996C6.90973 13.4823 7.01938 12.998 6.72849 12.7269L4.26275 10.447C3.97034 10.1774 3.49669 10.3252 3.40835 10.712L2.66665 13.9895C2.57832 14.3763 2.94384 14.7145 3.32306 14.5972L4.02517 14.3794C4.62218 15.2353 5.39891 15.9572 6.299 16.4903C7.41536 17.1512 8.6962 17.5 9.99989 17.5C11.3036 17.5 12.5829 17.1512 13.7008 16.4903C14.6009 15.9557 15.3776 15.2338 15.9746 14.3779ZM10.7766 5.1028C10.7766 5.2216 10.7492 5.3343 10.702 5.43634C10.5771 5.6983 10.3091 5.87953 9.99989 5.87953C9.69072 5.87953 9.42267 5.6983 9.29779 5.43634C9.24905 5.33582 9.22316 5.22312 9.22316 5.1028C9.22316 4.67484 9.57193 4.32608 9.99989 4.32608C10.4279 4.32608 10.7766 4.67484 10.7766 5.1028Z" fill="#9AA3B0"/>
            </svg>
            Ports
          </router-link>
          <template v-if="$route.path.indexOf('folders/countries') >= 0 && isOpenLeft">
            <folders-drop  @linkTo="linkTo" :link_active="true" :sequenceOfLinkNestings="getSequenceOfLinkNestings" :activeType="getActiveType" :activeObject="getActiveObject" :activeFolder="getActiveFolder" class="pl24" v-for="(item, i) in foldersList" :key="i" :item="item"></folders-drop>
            <pagination-panel-default @load-more="loadNextCountries" :if-active="loadingNextPageCountries" v-if="portsCurrentPage<portsTotalPage"></pagination-panel-default>

          </template>
        </div>
        <div class="wrap-router">
          <router-link :to="{name: 'Folders - Counterparties', params: {is_archive_counterparties: false}}" :class="{'active': $route.path.indexOf('folders/counterparties') >= 0}" class="h36 w100Proc border-radius-4 fz16 text-dark fw500 d-flex align-items-center mt4 p8 box-border">
            <svg v-on:click="(e)=>clickArrow(e, $route.path.indexOf('folders/counterparties') >= 0)"  :class="{'rotate-180': $route.path.indexOf('folders/counterparties') >= 0 && isOpenLeft}" class="mr8" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.27557 4.39844C9.54284 4.39844 9.67669 4.72158 9.4877 4.91057L6.21196 8.18631C6.0948 8.30346 5.90485 8.30346 5.78769 8.18631L2.51197 4.91057C2.32298 4.72158 2.45683 4.39844 2.7241 4.39844L9.27557 4.39844Z" fill="#9AA3B0"/>
            </svg>
            <svg class="mr8" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.3339 6.4974C12.3339 7.78606 11.2893 8.83073 10.0006 8.83073C8.71195 8.83073 7.66728 7.78606 7.66728 6.4974C7.66728 5.20873 8.71195 4.16406 10.0006 4.16406C11.2893 4.16406 12.3339 5.20873 12.3339 6.4974Z" fill="#9AA3B0"/>
              <path d="M10.0006 9.4974C6.17469 9.4974 6.33395 12.9201 6.33395 15.4974C6.33395 15.4974 7.59258 16.4974 10.334 16.4974C13.0754 16.4974 13.6673 15.4974 13.6673 15.4974C13.6673 12.9201 13.8265 9.4974 10.0006 9.4974Z" fill="#9AA3B0"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5704 14.7756C14.5521 13.0777 14.4214 11.2369 13.4972 10.0025C13.9295 9.7103 14.5219 9.53604 15.3337 9.53604C18.3441 9.53604 18.3381 11.9328 18.3333 13.8514C18.3331 13.9272 18.3329 14.0024 18.3329 14.0766C18.3329 14.0766 17.8487 14.8333 15.6063 14.8333C15.2265 14.8333 14.8815 14.8116 14.5704 14.7756ZM6.63792 10.1012C5.73829 11.3454 5.55945 13.1554 5.52419 14.8147C5.34406 14.8267 5.14957 14.8333 4.93968 14.8333C2.69729 14.8333 1.66776 14.0766 1.66776 14.0766C1.66776 14.0024 1.66757 13.9272 1.66738 13.8514C1.66257 11.9328 1.65655 9.53604 4.66699 9.53604C5.56638 9.53604 6.19654 9.74997 6.63792 10.1012ZM6.57559 7.26577C6.57559 8.24097 5.72108 9.03153 4.66699 9.03153C3.6129 9.03153 2.75839 8.24097 2.75839 7.26577C2.75839 6.29056 3.6129 5.5 4.66699 5.5C5.72108 5.5 6.57559 6.29056 6.57559 7.26577ZM15.3337 9.03153C16.3877 9.03153 17.2423 8.24097 17.2423 7.26577C17.2423 6.29056 16.3877 5.5 15.3337 5.5C14.2796 5.5 13.4251 6.29056 13.4251 7.26577C13.4251 8.24097 14.2796 9.03153 15.3337 9.03153Z" fill="#9AA3B0"/>
            </svg>
            Counterparties
          </router-link>
          <template v-if="$route.path.indexOf('folders/counterparties') >= 0 && isOpenLeft">
            <folders-drop @linkTo="linkTo" :link_active="true" :sequenceOfLinkNestings="getSequenceOfLinkNestings" :activeFolder="getActiveFolder" class="pl24" v-for="(item, i) in foldersList" :key="i" :item="item"></folders-drop>
            <pagination-panel-default :if-active="loadMoreClientBool" @load-more="loadMoreClient" v-if="nextLinkClientLeftList"></pagination-panel-default>

          </template>
        </div>
        <div class="wrap-router">
          <router-link :to="{name: 'Folders - Important', params: {is_archive_important: false}}" :class="{'active': $route.path.indexOf('folders/important') >= 0}" class="h36 w100Proc border-radius-4 fz16 text-dark fw500 d-flex align-items-center mt4 p8 box-border">
            <svg class="mr8 opacity-0" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.27557 4.39844C9.54284 4.39844 9.67669 4.72158 9.4877 4.91057L6.21196 8.18631C6.0948 8.30346 5.90485 8.30346 5.78769 8.18631L2.51197 4.91057C2.32298 4.72158 2.45683 4.39844 2.7241 4.39844L9.27557 4.39844Z" fill="#9AA3B0"/>
            </svg>
            <svg class="mr8" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.0124 8.12842C17.9063 7.80231 17.6171 7.57143 17.2762 7.54059L12.6271 7.11851L10.7898 2.81688C10.6541 2.50085 10.3454 2.29688 10.0019 2.29688C9.65831 2.29688 9.34953 2.50085 9.21473 2.81688L7.37738 7.11851L2.72752 7.54059C2.38667 7.57204 2.09803 7.80292 1.99137 8.12842C1.88533 8.45453 1.98326 8.81222 2.24106 9.03831L5.75542 12.1199L4.71921 16.6837C4.6434 17.0193 4.77364 17.3663 5.05208 17.5676C5.20174 17.6763 5.37758 17.7306 5.55403 17.7306C5.70565 17.7306 5.85741 17.6903 5.99294 17.6092L10.0019 15.2122L14.0101 17.6092C14.3041 17.785 14.6738 17.7689 14.9517 17.5676C15.2301 17.3663 15.3603 17.0193 15.2845 16.6837L14.2483 12.1199L17.7627 9.03831C18.0204 8.81222 18.1184 8.45527 18.0124 8.12842Z" fill="#9AA3B0"/>
            </svg>
            Important
          </router-link>
        </div>
      </div>
      <div class="flex-grow-1 box-border pt12 pr12 pb12 overflow-y-auto pl28 wrap-page">
        <div class="top-panel-content d-flex align-items-center">
          <p class="fz20 fw500 text-dark" :key="routeChange">{{nameSection ? nameSection : getNameSection()}}</p>
<!--          nameSectionFolders-->
          <template v-if="$route.name !== 'Folders - Ports Countries Ports Options' && $route.name !== 'Folders - Vessels Options'">
            <folders-sort-by :hideLastUpdated="$route.name !== 'Folders - Ports Countries Ports' && $route.name !== 'Folders - Ports'" v-model="sort" class="ml-auto" v-if="$route.path.indexOf('folders/payments') == -1 && $route.name !== 'Folders - Vessels Option CashFlow' && $route.name !== 'Folders - Vessels Option Acc Invoice' && $route.name !== 'Folders - Vessels Option Charterers' && $route.name !== 'Folders - Counterparties Options Payment'"></folders-sort-by>
            <folders-sort-by-payment v-model="sort" class="ml-auto" v-else-if="$route.name !== 'Folders - Vessels Option Charterers'"></folders-sort-by-payment>
            <folders-sort-by-charterers v-model="sort" class="ml-auto" v-else></folders-sort-by-charterers>
          </template>

          <div class="position-relative d-flex align-items-center ml22" v-if="$route.name !== 'Folders - Ports Countries Ports Options' && $route.name !== 'Folders - Vessels Options'">
            <svg class="position-absolute l8" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.8045 18.862L15.2545 14.312C16.1359 13.2233 16.6665 11.84 16.6665 10.3333C16.6665 6.84134 13.8252 4 10.3332 4C6.84128 4 4 6.84131 4 10.3333C4 13.8253 6.84131 16.6667 10.3333 16.6667C11.8399 16.6667 13.2232 16.136 14.3119 15.2547L18.8618 19.8047C18.9918 19.9347 19.1625 20 19.3332 20C19.5039 20 19.6745 19.9347 19.8045 19.8047C20.0652 19.544 20.0652 19.1227 19.8045 18.862ZM10.3333 15.3333C7.57596 15.3333 5.33333 13.0907 5.33333 10.3333C5.33333 7.57597 7.57596 5.33331 10.3333 5.33331C13.0906 5.33331 15.3332 7.57597 15.3332 10.3333C15.3332 13.0907 13.0906 15.3333 10.3333 15.3333Z" fill="#2C2C2C"/>
            </svg>
            <input placeholder="Search" type="text" class="h32 w200 pl40 bgc-modal" v-model.lazy="search">
          </div>
          <div class="ml-auto" v-else></div>
          <button v-on:click="setListViewFoldersPage(!listView)" class="ml8 d-flex align-items-center justify-center" Ж>
            <svg v-if="!listView" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24.1017 22.5388H12.0633C11.5672 22.5388 11.165 22.1366 11.165 21.6405C11.165 21.1443 11.5672 20.7422 12.0633 20.7422H24.1014C24.5975 20.7422 24.9997 21.1443 24.9997 21.6405C24.9997 22.1366 24.5978 22.5388 24.1017 22.5388Z" fill="#2C2C2C"/>
              <path d="M24.1007 16.906H12.0624C11.5662 16.906 11.1641 16.5038 11.1641 16.0077C11.1641 15.5115 11.5662 15.1094 12.0624 15.1094H24.1004C24.5966 15.1094 24.9987 15.5115 24.9987 16.0077C24.999 16.5038 24.5969 16.906 24.1007 16.906Z" fill="#2C2C2C"/>
              <path d="M24.1007 11.2575H12.0624C11.5662 11.2575 11.1641 10.8554 11.1641 10.3592C11.1641 9.86307 11.5662 9.46094 12.0624 9.46094H24.1004C24.5966 9.46094 24.9987 9.86307 24.9987 10.3592C24.9987 10.8554 24.5969 11.2575 24.1007 11.2575Z" fill="#2C2C2C"/>
              <path d="M8.20446 11.6394C8.87074 11.6394 9.41087 11.0993 9.41087 10.433C9.41087 9.76669 8.87074 9.22656 8.20446 9.22656C7.53817 9.22656 6.99805 9.76669 6.99805 10.433C6.99805 11.0993 7.53817 11.6394 8.20446 11.6394Z" fill="#2C2C2C"/>
              <path d="M8.20446 17.2019C8.87074 17.2019 9.41087 16.6618 9.41087 15.9955C9.41087 15.3292 8.87074 14.7891 8.20446 14.7891C7.53817 14.7891 6.99805 15.3292 6.99805 15.9955C6.99805 16.6618 7.53817 17.2019 8.20446 17.2019Z" fill="#2C2C2C"/>
              <path d="M8.20446 22.78C8.87074 22.78 9.41087 22.2399 9.41087 21.5736C9.41087 20.9073 8.87074 20.3672 8.20446 20.3672C7.53817 20.3672 6.99805 20.9073 6.99805 21.5736C6.99805 22.2399 7.53817 22.78 8.20446 22.78Z" fill="#2C2C2C"/>
            </svg>
            <svg v-else width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="8.7" y="8.7" width="5.6" height="5.6" rx="1.3" stroke="#2C2C2C" stroke-width="1.4"/>
              <rect x="17.7" y="8.7" width="5.6" height="5.6" rx="1.3" stroke="#2C2C2C" stroke-width="1.4"/>
              <rect x="8.7" y="17.7" width="5.6" height="5.6" rx="1.3" stroke="#2C2C2C" stroke-width="1.4"/>
              <rect x="17.7" y="17.7" width="5.6" height="5.6" rx="1.3" stroke="#2C2C2C" stroke-width="1.4"/>
            </svg>
          </button>
        </div>
        <div class="folders-content pb120">
          <div class="folders-menu d-flex align-items-center mt16" v-if="$route.path.indexOf('shared-with-me') == -1 && $route.path.indexOf('archive') === -1 && $route.name !== 'Folders - Ports Countries Ports Options Contacts' && $route.name !== 'Folders - Ports Countries Ports Options Berth List' && $route.name !== 'Folders - Ports Countries Ports Options' && $route.name !== 'Folders - Ports Countries Ports' &&$route.name !== 'Folders - Vessels Option Acc Invoice' && $route.name !== 'Folders - Vessels Option Charterers Files' && $route.name !== 'Folders - Vessels Option Charterers' && $route.name !== 'Folders - Vessels Option CashFlow' && $route.name !== 'Folders - Counterparties Options Payment' && $route.name !== 'Folders - Vessels Option Acc Invoice' && $route.name !== 'Folders - Vessels Options' && $route.name !== 'Folders - Important' && $route.name !== 'Folders - Counterparties' && $route.name !== 'Folders - Ports' && $route.name !== 'Folders - Vessels' && $route.name !== 'Folders - Tasks' && $route.name !== 'Folders - Payments' && $route.name !== 'Folders - Tasks Archive' && $route.name !== 'Folders - Tasks' && $route.name !== 'Folders - Counterparties Options' && (''+$route.params.is_archive_files) !== 'true' && (''+$route.params.files_is_archive) !== 'true'">
            <button class="button-blue-border w140 h32 p0 whitespace-nowrap fz14 mr8" v-on:click="showModalCreateFolder = true" v-if="$route.name !== 'Folders - Ports Countries Ports Options Contact Files' && $route.name !== 'Folders - Ports Countries Ports Options Berth List Detail' && $route.name !== 'Folders - Vessels Option Owners' && $route.name !== 'Folders - Payments File'">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.2241 13.2218H7.77975V9.77734C7.77975 9.3481 7.43126 8.99961 7.00188 8.99961C6.57264 8.99961 6.22415 9.3481 6.22415 9.77734V13.2218H2.77968C2.35044 13.2218 2.00195 13.5703 2.00195 13.9995C2.00195 14.4289 2.35044 14.7774 2.77968 14.7774H6.22415V18.2217C6.22415 18.6511 6.57264 18.9996 7.00188 18.9996C7.43126 18.9996 7.77975 18.6511 7.77975 18.2217V14.7774H11.2241C11.6535 14.7774 12.002 14.4289 12.002 13.9995C12.002 13.5703 11.6535 13.2218 11.2241 13.2218Z" fill="#094172"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.20038 4.4C5.48241 4.4 4.90038 4.98203 4.90038 5.7V6.7C4.90038 7.0866 4.58698 7.4 4.20038 7.4C3.81378 7.4 3.50038 7.0866 3.50038 6.7V5.7C3.50038 4.20883 4.70921 3 6.20038 3H9.53974C10.5087 3 11.4033 3.51917 11.884 4.36042L12.7323 5.3831C12.9638 5.78814 13.3945 6.03812 13.861 6.03812H18.2004C19.6916 6.03812 20.9004 7.24695 20.9004 8.73811V15.7C20.9004 17.1912 19.6916 18.4 18.2004 18.4H14.2004C13.8138 18.4 13.5004 18.0866 13.5004 17.7C13.5004 17.3134 13.8138 17 14.2004 17H18.2004C18.9184 17 19.5004 16.418 19.5004 15.7V8.73811C19.5004 8.02014 18.9184 7.43811 18.2004 7.43811H13.861C12.8921 7.43811 11.9975 6.91894 11.5168 6.07769L10.6685 5.05502C10.437 4.64997 10.0063 4.4 9.53974 4.4H6.20038Z" fill="#094172"/>
              </svg>
              Create Folder
            </button>
            <button class="button-blue-border w140 h32 p0 whitespace-nowrap fz14 mr8 position-relative">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.29961 4.9C6.58164 4.9 5.99961 5.48203 5.99961 6.2V17.7C5.99961 18.418 6.58164 19 7.29961 19H11.0996V13.9299L9.30263 15.7868C9.03378 16.0646 8.59062 16.0718 8.31281 15.803C8.035 15.5341 8.02774 15.091 8.29659 14.8132L11.2966 11.7132C11.4285 11.5769 11.61 11.5 11.7996 11.5C11.9892 11.5 12.1708 11.5769 12.3026 11.7132L15.3026 14.8132C15.5715 15.091 15.5642 15.5341 15.2864 15.803C15.0086 16.0718 14.5654 16.0646 14.2966 15.7868L12.4996 13.9299V19H16.2996C17.0176 19 17.5996 18.418 17.5996 17.7V10.9H14.2996C12.8084 10.9 11.5996 9.69117 11.5996 8.2V4.9H7.29961ZM12.9996 5.88995L16.6097 9.5H14.2996C13.5816 9.5 12.9996 8.91797 12.9996 8.2V5.88995ZM4.59961 6.2C4.59961 4.70883 5.80844 3.5 7.29961 3.5H12.5896L18.9996 9.91005V17.7C18.9996 19.1912 17.7908 20.4 16.2996 20.4H7.29961C5.80844 20.4 4.59961 19.1912 4.59961 17.7V6.2Z" fill="#094172"/>
              </svg>
              Upload File
              <input type="file" multiple class="upload" @change="uploadFile">
            </button>
            <button class="button-blue-border w140 h32 p0 whitespace-nowrap fz14 position-relative" v-if="$route.name !== 'Folders - Ports Countries Ports Options Contact Files' && $route.name !== 'Folders - Ports Countries Ports Options Berth List Detail' && $route.name !== 'Folders - Vessels Option Owners' && $route.name !== 'Folders - Payments File'">
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.4998 4.69687C5.78183 4.69687 5.1998 5.2789 5.1998 5.99688V16.4969C5.1998 17.2148 5.78183 17.7969 6.4998 17.7969H11.7998V12.7268L10.0028 14.5836C9.73397 14.8614 9.29081 14.8687 9.01301 14.5998C8.7352 14.331 8.72794 13.8878 8.99679 13.61L11.9968 10.5101C12.1287 10.3738 12.3102 10.2969 12.4998 10.2969C12.6894 10.2969 12.8709 10.3738 13.0028 10.5101L16.0028 13.61C16.2717 13.8878 16.2644 14.331 15.9866 14.5998C15.7088 14.8687 15.2656 14.8614 14.9968 14.5836L13.1998 12.7268V17.7969H18.4998C19.2178 17.7969 19.7998 17.2148 19.7998 16.4969V9.49687C19.7998 8.7789 19.2178 8.19687 18.4998 8.19687H14.4197C13.6315 8.19687 12.8826 7.85246 12.3697 7.25401L10.567 5.15085C10.32 4.86271 9.95944 4.69687 9.57993 4.69687H6.4998ZM3.7998 5.99688C3.7998 4.50571 5.00864 3.29688 6.4998 3.29688H9.57993C10.3681 3.29688 11.117 3.64129 11.6299 4.23974L13.4326 6.3429C13.6796 6.63104 14.0402 6.79688 14.4197 6.79688H18.4998C19.991 6.79688 21.1998 8.00571 21.1998 9.49687V16.4969C21.1998 17.988 19.991 19.1969 18.4998 19.1969H6.4998C5.00864 19.1969 3.7998 17.988 3.7998 16.4969V5.99688Z" fill="#094172"/>
              </svg>
              Upload Folder
              <input type="file"  class="upload" webkitdirectory directory multiple @change="uploadFolder">
            </button>
          </div>
        <router-view :routeChange="routeChange" :search="search" :sort="sort"></router-view>
        </div>
      </div>
      <folders-activity class="w274 box-border p24 pl12 pt16 overflow-y-auto"></folders-activity>
    </div>
    <div class="bottom-panel p-12-24 box-border bgc-white h48 box-border w100vw d-flex align-items-center position-fixed b0 l0 z-100" v-if="selected.length">
      <p class="fz16 text-dark fw500">Selected: {{selected.length}}</p>
      <button class="blue-button-text fz13 fw500 ml-auto" v-if="$route.path.indexOf('importnat') == -1 && $route.path.indexOf('archive') == -1 && $route.path.indexOf('shared-with-me') == -1 && $route.path.indexOf('payment') == -1" v-on:click="showModalOpenAccessBoolMeth(true)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.78947 6.36842C7.00465 6.36842 6.36842 7.00465 6.36842 7.78947V16.2105C6.36842 16.9954 7.00465 17.6316 7.78947 17.6316H16.2105C16.9954 17.6316 17.6316 16.9954 17.6316 16.2105V14.1053C17.6316 13.7274 17.9379 13.4211 18.3158 13.4211C18.6937 13.4211 19 13.7274 19 14.1053V16.2105C19 17.7511 17.7511 19 16.2105 19H7.78947C6.24889 19 5 17.7511 5 16.2105V7.78947C5 6.24889 6.24889 5 7.78947 5H9.89474C10.2726 5 10.5789 5.30633 10.5789 5.68421C10.5789 6.06209 10.2726 6.36842 9.89474 6.36842H7.78947ZM13.4211 5.68421C13.4211 5.30633 13.7274 5 14.1053 5H18.3158C18.6937 5 19 5.30633 19 5.68421V9.89474C19 10.2726 18.6937 10.5789 18.3158 10.5789C17.9379 10.5789 17.6316 10.2726 17.6316 9.89474V7.33604L12.4838 12.4838C12.2166 12.751 11.7834 12.751 11.5162 12.4838C11.249 12.2166 11.249 11.7834 11.5162 11.5162L16.664 6.36842H14.1053C13.7274 6.36842 13.4211 6.06209 13.4211 5.68421Z" fill="#094172"/>
        </svg>
        To open access
      </button>
      <button class="blue-button-text-stroke fz13 fw500 ml24" v-if="$route.path.indexOf('importnat') == -1 && $route.path.indexOf('archive') == -1 && $route.path.indexOf('shared-with-me') == -1" v-on:click="setFoldersForMoveTo(selected)">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 5.16927L7 5.16927C5.89543 5.16927 5 6.0647 5 7.16927L5 16.8359C5 17.9405 5.89543 18.8359 7 18.8359L12 18.8359" stroke="#094172" stroke-width="1.4" stroke-linecap="round"/>
          <path d="M11 12L20 12M20 12L16.0143 8M20 12L16.0143 16" stroke="#094172" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Move to
      </button>
      <button class="blue-button-text-stroke fz13 fw500 ml24"  v-on:click="downloadAll" :disabled="disabledDownloadAll" v-if="$route.path.indexOf('archive') == -1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.3335 5V14M12.3335 14L16.3335 10.0143M12.3335 14L8.33347 10.0143M19.0002 16V17C19.0002 18.1046 18.1047 19 17.0002 19H7.33349C6.22892 19 5.33348 18.1046 5.33348 17V16" stroke="#094172" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Download
      </button>
      <button class="blue-button-text fz13 fw500 ml24" v-on:click="showArchiveModal = true" v-if="$route.path.indexOf('importnat') == -1 && $route.path.indexOf('archive') == -1 && $route.path.indexOf('shared-with-me') == -1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z" fill="#094172"/>
        </svg>
        Archive
      </button>
      <button class="blue-button-text fz13 fw500 ml-auto" v-on:click="deleteForeverModalShow = true" v-if="$route.path.indexOf('importnat') == -1 && $route.path.indexOf('archive') >= 0 && $route.path.indexOf('shared-with-me') == -1 && $route.name !== 'Folders - Shared with me Archive'">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z" fill="#094172"/>
        </svg>
        Delete forever
      </button>
      <button class="blue-button-text fz13 fw500 ml24" v-on:click="unarchiveSelected" v-if="$route.path.indexOf('importnat') == -1 && $route.path.indexOf('archive') >= 0 && $route.path.indexOf('shared-with-me') == -1 && $route.name !== 'Folders - Shared with me Archive'">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.01736 9.78525L6.71267 7.00237L9.01736 4.21949C9.28441 3.91345 9.25326 3.44872 8.94722 3.18143C8.64119 2.91438 8.1767 2.94578 7.90916 3.25157L5.18172 6.51852C4.93943 6.79562 4.93943 7.20934 5.18172 7.48644L7.9092 10.7534C8.05485 10.9197 8.25865 11.005 8.46365 11.005C8.63532 11.005 8.80769 10.9452 8.94722 10.8233C9.25329 10.556 9.28465 10.0913 9.01736 9.78525Z" fill="#094172"/>
          <path d="M13.6538 6.26562H5.73568C5.32934 6.26562 5 6.59493 5 7.0013C5 7.40764 5.32934 7.73698 5.73568 7.73698H13.6538C15.7904 7.73698 17.5286 9.60036 17.5286 11.9785C17.5286 14.3567 15.7904 16.4862 13.6538 16.4862H6.71661C6.31027 16.4862 5.98093 16.8155 5.98093 17.2219C5.98093 17.6282 6.31027 17.9576 6.71661 17.9576H13.6538C16.6014 17.9576 19 15.212 19 11.9785C19 8.74505 16.6017 6.26562 13.6538 6.26562Z" fill="#094172"/>
        </svg>
        Unarchive
      </button>
      <button class="button-text-red fz13 fw500 ml24" v-on:click="clearSelectedFoldersPage">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.51375 7.57727C6.21612 7.28258 6.21612 6.80478 6.51375 6.51008C6.81138 6.21539 7.29392 6.21539 7.59155 6.51008L17.4863 16.2961C17.784 16.5908 17.784 17.0685 17.4863 17.3632C17.1887 17.6579 16.7062 17.6579 16.4085 17.3632L6.51375 7.57727Z" fill="#E85353"/>
          <path d="M16.4086 6.634C16.7063 6.33931 17.1888 6.33931 17.4864 6.634C17.7841 6.9287 17.7841 7.4065 17.4864 7.70119L7.59165 17.4872C7.29402 17.7819 6.81148 17.7819 6.51385 17.4872C6.21622 17.1925 6.21622 16.7147 6.51385 16.42L16.4086 6.634Z" fill="#E85353"/>
        </svg>
        Cancel
      </button>
    </div>
    <folders-modal-add-folder @create="createFolder" @close="showModalCreateFolder = false" v-if="showModalCreateFolder"></folders-modal-add-folder>
    <folders-to-open-access :selected="selected" @close="showModalOpenAccess" v-if="showModalOpenAccessBool"></folders-to-open-access>
    <folders-modal-move-to :unarchiveView="$route.path.indexOf('archive') >= 0" @addedFolder="loadFiles" @close="setFoldersForMoveTo([])" v-if="Array.isArray(foldersForMoveTo) === true && foldersForMoveTo.length"></folders-modal-move-to>
    <folders-modal-archive @archived="clearSelectedFoldersPage" @close="showArchiveModal = false" v-if="showArchiveModal" :items="selected"></folders-modal-archive>
    <folders-modal-delete :isSelectedMode="true" @close="()=>{deleteForeverModalShow = null}" :items="selected" v-if="deleteForeverModalShow"></folders-modal-delete>
  </div>
</template>

<script>
import FoldersSortBy from "@/components/folders/folders-sort-by";
import moment from 'moment'
import FoldersDrop from "@/components/folders/folders-drop";
import {mapActions, mapMutations, mapState} from "vuex";
import FoldersModalAddFolder from "@/components/folders/folders-modal-add-folder";
import FoldersToOpenAccess from "@/components/folders/folders-to-open-access";
import FoldersModalMoveTo from "@/components/folders/folders-modal-move-to";
import JSZip from "jszip";
import FoldersModalArchive from "@/components/folders/folders-lists/folders-modal-archive";
import FoldersActivity from "@/components/folders/folders-activity";
import FoldersSortByPayment from "@/components/folders/folders-sort-by-payment";
import PaginationPanelDefault from "@/components/ports/paginationDefault";
import axios from "axios";
import FoldersSortByCharterers from "@/components/folders/folders-sort-by-charterers.vue";
import FoldersModalDelete from "@/components/folders/folders-modal-delete.vue";
export default {
  name: "foldersPage",
  components: {
    FoldersModalDelete,
    FoldersSortByCharterers,
    PaginationPanelDefault,
    FoldersSortByPayment,
    FoldersActivity,
    FoldersModalArchive,
    FoldersModalMoveTo, FoldersToOpenAccess, FoldersModalAddFolder, FoldersDrop, FoldersSortBy},
  computed: {
    ...mapState({
      nextLinkPaymentLeftList: state => state.folders.nextLinkPaymentLeftList,
      foldersList: state => state.folders.foldersList,
      folders: state => state.folders.folders,
      listSectionsIds: state => state.folders.listSectionsIds,
      foldersForMoveTo: state => state.folders.foldersForMoveTo,
      selected: state=> state.folders.selected,
      listView: state=> state.folders.listView,
      nameSectionFolders: state => state.folders.nameSectionFolders,
      showModalOpenAccessBool: state => state.folders.showModalOpenAccessBool,
      emitSetCurrentFoldersInLeftMenuActualObject: state => state.folders.emitSetCurrentFoldersInLeftMenuActualObject,
    }),
    getActiveType() {
      if((this.$route.path.indexOf('payment') >= 0 || this.$route.path.indexOf('cash-flow') >= 0 || this.$route.path.indexOf('acc-invoice') >= 0) && this.$route.params.detailData ) {
        return  'payment'
      }
      if(this.$route.params.charterersDetail) {
        let detail = JSON.parse(this.$route.params.charterersDetail)
        return detail.type == 'sublet' ? 'sublet' : 'voyage'
      }
      if(this.$route.path.indexOf('option/cash-flow') >= 0) {
        return 'vessel_cash_flow'
      }
      if(this.$route.path.indexOf('option/acc-invoice') >= 0) {
        return  'vessel_acc_invoice'
      }
      if(this.$route.path.indexOf('vessel-detail') >= 0) {
        return 'vessel_details'
      }
      if(this.$route.path.indexOf('option/owners') >=0 ) {
        return 'vessel_owners'
      }
      if(this.$route.path.indexOf('option/charterers') >= 0) {
        return 'vessel_charterers'
      }
      if(this.$route.path.indexOf('tasks') >= 0) {
        return 'task'
      }
      if(this.$route.path.indexOf('vessels') >=0) {
        return 'vessel'
      }
      return ''
    },
    getSequenceOfLinkNestings() {
      let obj = {}
      switch (this.nameSectionFolders) {
        case 'My Files':
          obj['folder'] = {
            routePath: 'Folders - My files Folder', // For open folder in folder
            routePathArchive: 'Folders - My files Folder Archive' // For open folder in folder (archive)
          }
          break;
        case 'Payments':
          obj['payment'] = {
            route: 'Folders - Payments Folders',
            routeArchive: 'Folders - Payments Folders Archive',
            folder: {
              routePath: 'Folders - Payments Folders Path',
              routePathArchive: 'Folders - Payments Folders Path Archive'
            }
          }
          break;
        case 'Tasks':
          obj = []
            if(this.$route.path.indexOf('tasks-a') >= 0) {
              obj.push({'pre_tasks': {
                  route: 'Folders - Tasks Archive',
                  routeArchive: 'Folders - Tasks Archive',
                  task: {
                    route: 'Folders - Tasks Archive Manually Files',
                    routeArchive: 'Folders - Tasks Archive Manually Files Archive',
                    folder: {
                      routePath: 'Folders - Tasks Archive Manually Files Path',
                      routePathArchive: 'Folders - Tasks Archive Manually Files Archive Path'
                    }
                  }
                }})
              obj.push({'pre_tasks': {
                  route: 'Folders - Tasks Archive',
                  routeArchive: 'Folders - Tasks Archive',
                  task: {
                    route: 'Folders - Tasks Archive Vessel Files',
                    routeArchive: 'Folders - Tasks Archive Vessel Files Archive',
                    folder: {
                      routePath: 'Folders - Tasks Archive Vessel Files Path',
                      routePathArchive: 'Folders - Tasks Archive Vessel Files Archive Path'
                    }
                  }
                }})
              obj.push({'pre_tasks': {
                  route: 'Folders - Tasks Archive',
                  routeArchive: 'Folders - Tasks Archive',
                  task: {
                    route: 'Folders - Tasks Archive Cargo Files',
                    routeArchive: 'Folders - Tasks Archive Cargo Files Archive',
                    folder: {
                      routePath: 'Folders - Tasks Archive Cargo Files Path',
                      routePathArchive: 'Folders - Tasks Archive Cargo Files Archive Path'
                    }
                  }
                }})
            } else {
              obj.push({'pre_tasks': {
                  route: 'Folders - Tasks',
                  routeArchive: 'Folders - Tasks Archive',
                  task: {
                    route: 'Folders - Tasks Manually Files',
                    routeArchive: 'Folders - Tasks Manually Files Archive',
                    folder: {
                      routePath: 'Folders - Tasks Manually Files Path',
                      routePathArchive: 'Folders - Tasks Manually Files Archive Path'
                    }
                  }
                }})
              obj.push({'pre_tasks': {
                  route: 'Folders - Tasks',
                  routeArchive: 'Folders - Tasks Archive',
                  task: {
                    route: 'Folders - Tasks Vessel Files',
                    routeArchive: 'Folders - Tasks Vessel Files Archive',
                    folder: {
                      routePath: 'Folders - Tasks Vessel Files Path',
                      routePathArchive: 'Folders - Tasks Vessel Files Archive Path'
                    }
                  }
                }})
              obj.push({'pre_tasks': {
                  route: 'Folders - Tasks',
                  routeArchive: 'Folders - Tasks Archive',
                  task: {
                    route: 'Folders - Tasks Cargo Files',
                    routeArchive: 'Folders - Tasks Cargo Files Archive',
                    folder: {
                      routePath: 'Folders - Tasks Cargo Files Path',
                      routePathArchive: 'Folders - Tasks Cargo Files Archive Path'
                    }
                  }
                }})
            }

          break;
        case 'Vessels': {
          obj = []

          obj.push({'actual_vessel':{
            route: 'Folders - Vessels',
            routeArchive: 'Folders - Vessels',
              vessel: {
                route: 'Folders - Vessels Options',
                routeArchive: 'Folders - Vessels Options',
                vessel_cash_flow: {
                  route: 'Folders - Vessels Option CashFlow',
                  routeArchive: 'Folders - Vessels Option CashFlow',
                  payment: {
                    route: 'Folders - Vessels Option CashFlow Files',
                    routeArchive: 'Folders - Vessels Option CashFlow Files',
                    folder: {
                      routePath: 'Folders - Vessels Option CashFlow Files Path',
                      routePathArchive: 'Folders - Vessels Option CashFlow Files Path'
                    }
                  }
                },
                vessel_details: {
                  route: 'Folders - Vessels Option Vessel Detail',
                  routeArchive: 'Folders - Vessels Option Vessel Detail',
                  folder: {
                    routePath: 'Folders - Vessels Option Vessel Detail Path',
                    routePathArchive: 'Folders - Vessels Option Vessel Detail Path'
                  }
                },
                vessel_owners: {
                  route: 'Folders - Vessels Option Owners',
                  routeArchive: 'Folders - Vessels Option Owners',
                },
                vessel_charterers: {
                  route: 'Folders - Vessels Option Charterers',
                  routeArchive: 'Folders - Vessels Option Charterers',
                  voyage: {
                    route: 'Folders - Vessels Option Charterers Files',
                    routeArchive: 'Folders - Vessels Option Charterers Files',
                    vessel_details: {
                      route: 'Folders - Vessels Option Charterers Files',
                      routeArchive: 'Folders - Vessels Option Charterers Files',
                      folder: {
                        routePath: 'Folders - Vessels Option Charterers Files Path',
                        routePathArchive: 'Folders - Vessels Option Charterers Files Path'
                      }
                    },
                    voyage_invoice: {
                      route: 'Folders - Vessels Option Charterers Files',
                      routeArchive: 'Folders - Vessels Option Charterers Files',
                    }
                  },
                  sublet: {
                    route: 'Folders - Vessels Option Charterers Files',
                    routeArchive: 'Folders - Vessels Option Charterers Files',
                    vessel_details: {
                      route: 'Folders - Vessels Option Charterers Files',
                      routeArchive: 'Folders - Vessels Option Charterers Files',
                      folder: {
                        routePath: 'Folders - Vessels Option Charterers Files Path',
                        routePathArchive: 'Folders - Vessels Option Charterers Files Path'
                      }
                    },
                    voyage_invoice: {
                      route: 'Folders - Vessels Option Charterers Files',
                      routeArchive: 'Folders - Vessels Option Charterers Files',
                    }

                  }
                },
                vessel_acc_invoice: {
                  route: 'Folders - Vessels Option Acc Invoice',
                  routeArchive: 'Folders - Vessels Option Acc Invoice',
                  payment: {
                    route: 'Folders - Vessels Option Acc Invoice File',
                    routeArchive: 'Folders - Vessels Option Acc Invoice File',
                    folder: {
                      routePath: 'Folders - Vessels Option Acc Invoice Files Path',
                      routePathArchive: 'Folders - Vessels Option Acc Invoice Files Path'
                    }
                  }
                }
              }
          }})
          obj.push({'redelivered_vessel': {
            route: 'Folders - Vessels',
            routeArchive: 'Folders - Vessels',
              vessels_by_year: {
                route: 'Folders - Vessels',
                routeArchive: 'Folders - Vessels',
                vessel: {
                  route: 'Folders - Vessels Options',
                  routeArchive: 'Folders - Vessels Options',
                  vessel_cash_flow: {
                    route: 'Folders - Vessels Option CashFlow',
                    routeArchive: 'Folders - Vessels Option CashFlow',
                    payment: {
                      route: 'Folders - Vessels Option CashFlow Files',
                      routeArchive: 'Folders - Vessels Option CashFlow Files',
                      folder: {
                        routePath: 'Folders - Vessels Option CashFlow Files Path',
                        routePathArchive: 'Folders - Vessels Option CashFlow Files Path'
                      }
                    }
                  },
                  vessel_details: {
                    route: 'Folders - Vessels Option Vessel Detail',
                    routeArchive: 'Folders - Vessels Option Vessel Detail',
                    folder: {
                      routePath: 'Folders - Vessels Option Vessel Detail Path',
                      routePathArchive: 'Folders - Vessels Option Vessel Detail Path'
                    }
                  },
                  vessel_owners: {
                    route: 'Folders - Vessels Option Owners',
                    routeArchive: 'Folders - Vessels Option Owners',
                  },
                  vessel_charterers: {
                    route: 'Folders - Vessels Option Charterers',
                    routeArchive: 'Folders - Vessels Option Charterers',
                    voyage: {
                      route: 'Folders - Vessels Option Charterers Files',
                      routeArchive: 'Folders - Vessels Option Charterers Files',
                      vessel_details: {
                        route: 'Folders - Vessels Option Charterers Files',
                        routeArchive: 'Folders - Vessels Option Charterers Files',
                        folder: {
                          routePath: 'Folders - Vessels Option Charterers Files Path',
                          routePathArchive: 'Folders - Vessels Option Charterers Files Path'
                        }
                      },
                      voyage_invoice: {
                        route: 'Folders - Vessels Option Charterers Files',
                        routeArchive: 'Folders - Vessels Option Charterers Files',
                      }
                    },
                    sublet: {
                      route: 'Folders - Vessels Option Charterers Files',
                      routeArchive: 'Folders - Vessels Option Charterers Files',
                      vessel_details: {
                        route: 'Folders - Vessels Option Charterers Files',
                        routeArchive: 'Folders - Vessels Option Charterers Files',
                        folder: {
                          routePath: 'Folders - Vessels Option Charterers Files Path',
                          routePathArchive: 'Folders - Vessels Option Charterers Files Path'
                        }
                      },
                      voyage_invoice: {
                        route: 'Folders - Vessels Option Charterers Files',
                        routeArchive: 'Folders - Vessels Option Charterers Files',
                      }

                    }
                  },
                  vessel_acc_invoice: {
                    route: 'Folders - Vessels Option Acc Invoice',
                    routeArchive: 'Folders - Vessels Option Acc Invoice',
                    payment: {
                      route: 'Folders - Vessels Option Acc Invoice File',
                      routeArchive: 'Folders - Vessels Option Acc Invoice File',
                      folder: {
                        routePath: 'Folders - Vessels Option Acc Invoice Files Path',
                        routePathArchive: 'Folders - Vessels Option Acc Invoice Files Path'
                      }
                    }
                  }
                }

              }
          }})
          break;
        }
        case 'Ports':
          obj['country'] = {
            route: 'Folders - Ports Countries Ports',
            routeArchive: 'Folders - Ports Countries Ports',
            port: {
              route: 'Folders - Ports Countries Ports Options',
              routeArchive: 'Folders - Ports Countries Ports Options',
              port_details: {
                route: 'Folders - Ports Countries Ports Options Details',
                routeArchive: 'Folders - Ports Countries Ports Options Details',
                folder: {
                  routePath: 'Folders - Ports Countries Ports Options Details Path',
                  routePathArchive: 'Folders - Ports Countries Ports Options Details Path'
                }
              },
              port_berth_list: {
                route: 'Folders - Ports Countries Ports Options Berth List',
                routeArchive: 'Folders - Ports Countries Ports Options Berth List',
                berth_list: {
                  route: 'Folders - Ports Countries Ports Options Berth List Detail',
                  routeArchive: 'Folders - Ports Countries Ports Options Berth List Detail',
                }
              },
              port_contacts: {
                route: 'Folders - Ports Countries Ports Options Contacts',
                routeArchive: 'Folders - Ports Countries Ports Options Contacts',
                contacts: {
                  route: 'Folders - Ports Countries Ports Options Contact Files',
                  routeArchive: 'Folders - Ports Countries Ports Options Contact Files',
                }
              }
            }
          }
        break;
        case 'Counterparties':
          obj['counterparties'] = {
            route: 'Folders - Counterparties Options',
            routeArchive: 'Folders - Counterparties Options',
            counterparties_detail: {
              route: 'Folders - Counterparties Options Detail',
              routeArchive: 'Folders - Counterparties Options Detail',
              folder: {
                routePath: 'Folders - Counterparties Options Detail Path',
                routePathArchive: 'Folders - Counterparties Options Detail Path'
              }
            },
            counterparties_payments: {
              route: 'Folders - Counterparties Options Payment',
              routeArchive: 'Folders - Counterparties Options Payment',
              payment: {
                route: 'Folders - Counterparties Options Payment Detail',
                routeArchive: 'Folders - Counterparties Options Payment Detail',
                folder: {
                  routePath: 'Folders - Counterparties Options Payment Detail Path',
                  routePathArchive: 'Folders - Counterparties Options Payment Detail Path'
                }
              }
            }
          }
           break;
      }

      return obj
    },
    getActiveFolder() {
      let path = this.$route.params.path ? this.$route.params.path : null
      if(path) {
        path = JSON.parse(path)
        return path[path.length - 1].id
      }
      return null
    },
    getActiveObject() {

      if(this.$route.params.detailData) {
        return this.$route.params.detailData ? JSON.parse(this.$route.params.detailData).id : null
      }
      if(this.$route.params.charterersDetail) {
        return this.$route.params.charterersDetail ? JSON.parse(this.$route.params.charterersDetail).id : null
      }
      if(this.$route.params.detailList) {
        return this.$route.params.detailList ? JSON.parse(this.$route.params.detailList).id : null
      }
      if(this.$route.params.portDetail) {
        return this.$route.params.portDetail ? JSON.parse(this.$route.params.portDetail).id : null
      }
      if(this.$route.params.detailVessel) {
        return this.$route.params.detailVessel ? JSON.parse(this.$route.params.detailVessel).id : null
      }
      return null
    },
    getParentIdSection() {
      if(this.$route.path.indexOf('my-files')>= 0 || this.$route.path.indexOf('shared-with-me')>= 0) {
        if(this.$route.path.indexOf('archive')>= 0) {
          return this.listSectionsIds.find(a=> a.name == "archive") ? this.listSectionsIds.find(a=> a.name == "archive").id : null
        } else {
          return this.listSectionsIds.find(a=> a.name == "myfiles") ? this.listSectionsIds.find(a=> a.name == "myfiles").id : null
        }
      }
      return ''
    },
    getLinkToArchive() {
      if(this.$route.name == 'Folders - Counterparties Options Payment Detail') {
        return {name: 'Folders - Counterparties Options Payment Detail', params: {is_archive_files: true}}

      }
      if(this.$route.path.indexOf('my-files') >= 0) {
          return {name: 'Folders - My files Archive'}
      }
      if(this.$route.path.indexOf('shared-with')>=0) {
        return {name: 'Folders - Shared with me Archive'}
      }
      if(this.$route.path.indexOf('payments')>= 0) {
        return {name: 'Folders - Payments Archive'}
      }
      if(this.$route.path.indexOf('a-payment/')>=0) {
        return {name: 'Folders - Payments Folders Archive Path Archive' ,params: {detailData: this.$route.params.detailData}}
      }
      if(this.$route.path.indexOf('payment/')>=0) {
        return {name: 'Folders - Payments Folders Archive Path' ,params: {detailData: this.$route.params.detailData}}
      }
      if(this.$route.path.indexOf('tasks-a') >= 0) {
        if(this.$route.params.detailData) {
          if(this.$route.path.indexOf('manually') >= 0) {
            return {name: 'Folders - Tasks Archive Manually Files Archive', params: {detailData: this.$route.params.detailData}}
          } else if(this.$route.path.indexOf('vessel') >= 0) {
            return {name: 'Folders - Tasks Archive Vessel Files Archive', params: {detailData: this.$route.params.detailData}}
          } else if(this.$route.path.indexOf('cargo') >= 0) {
            return {name: 'Folders - Tasks Archive Cargo Files Archive', params: {detailData: this.$route.params.detailData}}
          }
        }
      }
      if(this.$route.path.indexOf('tasks') >=0) {
        if(this.$route.params.detailData) {
          if(this.$route.path.indexOf('manually') >= 0) {
            return {name: 'Folders - Tasks Manually Files Archive', params: {detailData: this.$route.params.detailData}}
          } else if(this.$route.path.indexOf('vessel') >= 0) {
            return {name: 'Folders - Tasks Vessel Files Archive', params: {detailData: this.$route.params.detailData}}
          } else if(this.$route.path.indexOf('cargo') >= 0) {
            return {name: 'Folders - Tasks Cargo Files Archive', params: {detailData: this.$route.params.detailData}}
          }
        }
        return {name: 'Folders - Tasks Archive'}
      }
      if(this.$route.name == 'Folders - Vessels') {
        return {name: 'Folders - Vessels', params: {vessels_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Vessels Options') {
        return {name: 'Folders - Vessels', params: {vessels_is_archive: true}}

        // return {name: 'Folders - Vessels Options', params: {vessels_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Vessels Option CashFlow') {
        return {name: 'Folders - Vessels Option CashFlow', params: {cash_flow_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Vessels Option CashFlow Files' || this.$route.name == 'Folders - Vessels Option CashFlow Files Path') {
        return {name: 'Folders - Vessels Option CashFlow Files', params: {files_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Vessels Option Vessel Detail' || this.$route.name == 'Folders - Vessels Option Vessel Detail Path') {
        return {name: 'Folders - Vessels Option Vessel Detail', params: {files_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Vessels Option Owners') {
        return {name: 'Folders - Vessels Option Owners', params: {owners_is_archive: true, ownersDetail: this.$route.params.ownersDetail}}
      }
      if(this.$route.name == 'Folders - Vessels Option Charterers') {
        // return {name: 'Folders - Vessels Option Charterers', params: {charterers_is_archive: true}}
        return {name: 'Folders - Vessels', params: {vessels_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Vessels Option Charterers Files') {
        return {name: 'Folders - Vessels Option Charterers Files', params: {files_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Vessels Option Charterers Path') {
        // return {name: 'Folders - Vessels Option Charterers', params: {charterers_is_archive: true}}
        return {name: 'Folders - Vessels Option Charterers Files', params: {files_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Vessels Option Acc Invoice') {
        return {name: 'Folders - Vessels Option Acc Invoice', params: {cash_flow_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Vessels Option Acc Invoice File' || this.$route.name == 'Folders - Vessels Option Acc Invoice Files Path') {
        return {name: 'Folders - Vessels Option Acc Invoice File', params: {files_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Ports') {
        return {name: 'Folders - Ports', params: {countries_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Ports Countries Ports') {
        return {name: 'Folders - Ports', params: {countries_is_archive: true}}
      }
      if(this.$route.name == 'Folders - Ports Countries Ports Options Details' || this.$route.name == 'Folders - Ports Countries Ports Options Details Path') {
        return {name: 'Folders - Ports Countries Ports Options Details', params: {is_archive_files: true}}
      }
      if(this.$route.name == 'Folders - Ports Countries Ports Options Berth List') {
        return  {name: 'Folders - Ports Countries Ports Options Berth List', params: {is_archive_berth_list: true}}
      }
      if(this.$route.name == 'Folders - Ports Countries Ports Options Berth List Detail') {
        return  {name: 'Folders - Ports Countries Ports Options Berth List Detail', params: {is_archive_files: true}}
      }
      if(this.$route.name == 'Folders - Ports Countries Ports Options Contacts') {
        return  {name: 'Folders - Ports Countries Ports Options Contacts', params: {is_archive_contacts: true}}
      }
      if(this.$route.name == 'Folders - Ports Countries Ports Options Contact Files') {
        return  {name: 'Folders - Ports Countries Ports Options Contact Files', params: {is_archive_files: true}}
      }
      if(this.$route.name == 'Folders - Counterparties Options Detail') {
        return  {name: 'Folders - Counterparties Options Detail', params: {is_archive_files: true}}
      }

      if(this.$route.name == 'Folders - Important' || this.$route.name == 'Folders - Important Path') {
        return {name: 'Folders - Important', params: {is_archive_important: true}}
      }
      return ''
    },
    getTypeFileBySection() {
      if(this.$route.path.indexOf('option/charterers') >= 0) {
        return 'vessels'
      }
      if(this.$route.path.indexOf('option/owners') >= 0) {
        return 'owners'
      }
      if(this.$route.path.indexOf('options/berth-list') >= 0) {
        return 'ports_berth_list'
      }
      if(this.$route.path.indexOf('options/contact') >= 0) {
        return 'ports_contracts'
      }
      if(this.$route.path.indexOf('port') >= 0 && this.$route.path.indexOf('details') >= 0) {
        return 'ports'
      }
      return this.$route.path.indexOf('my-files') >= 0 ? 'private' : this.$route.path.indexOf('tasks') >= 0 ? 'task' : (this.$route.path.indexOf('payments') || this.$route.path.indexOf('cash-flow') >= 0 || this.$route.path.indexOf('acc-invoice')>=0) ? 'payments' : this.$route.path.indexOf('vessels') >= 0 ? 'vessels' : this.$route.path.indexOf('ports') >= 0 ? 'ports' : ''
    },
    getPathToFolder() {
      return ''
    },
    getPathSection() {
      let links = []
      if(this.$route.path.indexOf('important') >= 0) {
        links.push({name: 'Important', to: {name: 'Folders - Important'}})
      }
      if(this.$route.path.indexOf('my-files') >= 0) {
        if(this.$route.path.indexOf('archive') >= 0) {
          links.push({name: 'My Files Archive', to: {name: 'Folders - My files Archive'}})
        } else {
          links.push({name: 'My Files', to: {name: 'Folders - My files'}})
        }
      }
      if(this.$route.path.indexOf('shared-with-me') >= 0) {
        if(this.$route.path.indexOf('archive') >= 0) {
          links.push({name: 'Shared with me Archive', to: {name: 'Folders - Shared with me Archive'}})
        } else {
          links.push({name: 'Shared with me', to: {name: 'Folders - Shared with me'}})
        }
      }

      if(this.$route.path.indexOf('payments') >= 0 && this.$route.path.indexOf('counterparties') == -1) {
        if(this.$route.path.indexOf('archive') >= 0) {
          links.push({name: 'Payments Archive', to: {name: 'Folders - Payments Archive'}})
        } else {
          links.push({name: 'Payments', to: {name: 'Folders - Payments'}})
        }
      }
      if(this.$route.path.indexOf('payment/') >= 0) {
        if(this.$route.path.indexOf('archive') >= 0) {
          let item = JSON.parse(this.$route.params.detailData)
          if(this.$route.path.indexOf('a-payment') >= 0) {
            links.push({name: 'Payments Archive', to: {name: 'Folders - Payments Archive'}})
            links.push({name: item.date + ' Archive', to: {name: 'Folders - Payments Folders Archive Path Archive', params: {detailData: this.$route.params.detailData}}})
          } else {
            links.push({name: 'Payments', to: {name: 'Folders - Payments'}})
            links.push({name: item.date + ' Archive', to: {name: 'Folders - Payments Folders Archive Path', params: {detailData: this.$route.params.detailData}}})

          }
        } else {
          let item = JSON.parse(this.$route.params.detailData)
          if(this.$route.path.indexOf('a-payment') >= 0) {
            links.push({name: 'Payments Archive', to: {name: 'Folders - Payments Archive'}})
            links.push({name: item.date, to: {name: 'Folders - Payments Folders Archive', params: {detailData: this.$route.params.detailData}}})
          } else {
            links.push({name: 'Payments', to: {name: 'Folders - Payments'}})
            links.push({name: item.date, to: {name: 'Folders - Payments Folders', params: {detailData: this.$route.params.detailData}}})
          }
        }
      }
      if(this.$route.path.indexOf('tasks') >= 0) {
        let item = this.$route.params.detailData ? JSON.parse(this.$route.params.detailData) : null
        if(this.$route.path.indexOf('tasks-a') >= 0) {
          links.push({name: 'Tasks Archive', to: {name: 'Folders - Tasks Archive'}})
          if(item) {
            if(this.$route.path.indexOf('manually') >= 0) {
              if(this.$route.path.indexOf('archive') >= 0) {
                links.push({name: item.name + ' Archive', to: {name: 'Folders - Tasks Archive Manually Files Archive', params: {detailData: this.$route.params.detailData}}})
              } else {
                links.push({name: item.name, to: {name: 'Folders - Tasks Archive Manually Files', params: {detailData: this.$route.params.detailData}}})
              }
            } else if(this.$route.path.indexOf('vessel') >= 0) {
              if(this.$route.path.indexOf('archive') >= 0) {
                links.push({name: item.name + ' Archive', to: {name: 'Folders - Tasks Archive Vessel Files Archive', params: {detailData: this.$route.params.detailData}}})
              } else {
                links.push({name: item.name, to: {name: 'Folders - Tasks Archive Vessel Files', params: {detailData: this.$route.params.detailData}}})
              }
            } else if(this.$route.path.indexOf('cargo') >= 0) {
              if(this.$route.path.indexOf('archive') >= 0) {
                links.push({name: item.name + ' Archive', to: {name: 'Folders - Tasks Archive Cargo Files Archive', params: {detailData: this.$route.params.detailData}}})
              } else {
                links.push({name: item.name, to: {name: 'Folders - Tasks Archive Cargo Files', params: {detailData: this.$route.params.detailData}}})
              }
            }
          }
        } else {
          links.push({name: 'Tasks', to: {name: 'Folders - Tasks'}})
          if(item) {
            if(this.$route.path.indexOf('manually') >= 0) {
              if(this.$route.path.indexOf('archive') >= 0) {
                links.push({name: item.name + ' Archive', to: {name: 'Folders - Tasks Manually Files Archive', params: {detailData: this.$route.params.detailData}}})
              } else {
                links.push({name: item.name, to: {name: 'Folders - Tasks Manually Files', params: {detailData: this.$route.params.detailData}}})
              }
            } else if(this.$route.path.indexOf('vessel') >= 0) {
              if(this.$route.path.indexOf('archive') >= 0) {
                links.push({name: item.name + ' Archive', to: {name: 'Folders - Tasks Vessel Files Archive', params: {detailData: this.$route.params.detailData}}})
              } else {
                links.push({name: item.name, to: {name: 'Folders - Tasks Vessel Files', params: {detailData: this.$route.params.detailData}}})
              }
            } else if(this.$route.path.indexOf('cargo') >= 0) {
              if(this.$route.path.indexOf('archive') >= 0) {
                links.push({name: item.name + ' Archive', to: {name: 'Folders - Tasks Cargo Files Archive', params: {detailData: this.$route.params.detailData}}})
              } else {
                links.push({name: item.name, to: {name: 'Folders - Tasks Cargo Files', params: {detailData: this.$route.params.detailData}}})
              }
            }
          }
        }

      }
      if(this.$route.path.indexOf('vessels') >= 0) {
        links.push({name: 'Vessels' + (''+this.$route.params.vessels_is_archive == 'true' ? ' Archive' : ''), to: {name: 'Folders - Vessels', params: {vessels_is_archive: this.$route.params.vessels_is_archive}}})
      }
      if(this.$route.path.indexOf('/option') >= 0 && this.$route.path.indexOf('vessels') >= 0) {
        let detail = JSON.parse(this.$route.params.detailVessel)
        links.push({name: detail.name + (detail.cp_date ? '/'+detail.cp_date : ''), to: {name: 'Folders - Vessels Options',}})
      }
      if(this.$route.path.indexOf('option/cash-flow') >= 0) {
        links.push({name: 'Cash Flow' + (''+this.$route.params.cash_flow_is_archive == 'true' ? ' Archive' : ''), to: {name: 'Folders - Vessels Option CashFlow'}})
      }
      if(this.$route.path.indexOf('option/acc-invoice') >= 0) {
        links.push({name: 'Acc. Invoices' + (''+this.$route.params.cash_flow_is_archive == 'true' ? ' Archive' : ''), to: {name: 'Folders - Vessels Option Acc Invoice'}})
      }
      if(this.$route.path.indexOf('option/cash-flow') >= 0 && this.$route.params.detailData) {
        let detail = JSON.parse(this.$route.params.detailData)
        links.push({name: (detail.date ? detail.date : 'Payment') + (''+this.$route.params.files_is_archive == 'true' ? ' Archive' : ''), to: {name: 'Folders - Vessels Option CashFlow Files'}})
      }
      if(this.$route.path.indexOf('option/acc-invoice') >= 0 && this.$route.params.detailData) {
        let detail = JSON.parse(this.$route.params.detailData)
        links.push({name: (detail.date ? detail.date : 'Payment') + (''+this.$route.params.files_is_archive == 'true' ? ' Archive' : ''), to: {name: 'Folders - Vessels Option Acc Invoice File'}})
      }
      if(this.$route.path.indexOf('vessel-detail') >= 0) {
        links.push({name: 'Vsl Details' + (''+this.$route.params.files_is_archive == 'true' ? ' Archive' : ''), to: {name: 'Folders - Vessels Option Vessel Detail'}})
      }
      if(this.$route.path.indexOf('option/charterers') >= 0) {
        links.push({name: 'Charterers', to: {name: 'Folders - Vessels Option Charterers'}})
      }
      if(this.$route.path.indexOf('option/charterers') >= 0 && this.$route.params.charterersDetail) {
        let detail = JSON.parse(this.$route.params.charterersDetail)
        links.push({name: (detail.type == 'Voyage' ? 'Voyage' : 'Sublet') + (detail.cp_date ? '/'+detail.cp_date : '') + (detail.owner_name ? '/'+detail.owner_name : '') + (this.$route.params.files_is_archive == 'true' ? ' Archive' : ''), to: {name: 'Folders - Vessels Option Charterers Files'}})
      }
      if(this.$route.path.indexOf('countries') >= 0) {
        links.push(({name: 'Countries' + (''+this.$route.params.countries_is_archive == 'true' ? ' Archive' : ''), to: {name: 'Folders - Ports'}}))
      }
      if(this.$route.path.indexOf('port') >= 0 && this.$route.path.indexOf('important') == -1) {
        let detail = JSON.parse(this.$route.params.countryDetail)
        links.push({name: detail.name, to: {name: 'Folders - Ports Countries Ports'}})
      }
      if(this.$route.path.indexOf('options') >= 0 && this.$route.path.indexOf('countries') >= 0) {
        let detail = JSON.parse(this.$route.params.portDetail)
        links.push({name: detail.name, to: {name: 'Folders - Ports Countries Ports Options'}})
      }
      if(this.$route.path.indexOf('port') >= 0 && this.$route.path.indexOf('details') >= 0 && this.$route.path.indexOf('important') == -1) {
        links.push({name: 'Details' + (''+this.$route.params.is_archive_files == 'true' ? ' Archive' : ''), to: {name: 'Folders - Ports Countries Ports Options Details'}})
      }
      if(this.$route.path.indexOf('options/berth-list') >= 0) {
        links.push({name: 'Berth List' + (''+this.$route.params.is_archive_berth_list == 'true' ? ' Archive' : ''), to: {name: 'Folders - Ports Countries Ports Options Berth List'}})
      }
      if(this.$route.path.indexOf('options/berth-list') >= 0 && this.$route.path.indexOf('detail') >= 0) {
        let detail = JSON.parse(this.$route.params.detailList)
        links.push({name: detail.name + (''+this.$route.params.is_archive_files == 'true' ? ' Archive' : ''), to: {name: 'Folders - Ports Countries Ports Options Berth List Detail'}})
      }
      if(this.$route.path.indexOf('options/contact') >= 0) {
        links.push({name: 'Contacts' + (''+this.$route.params.is_archive_contacts == 'true' ? ' Archive' : ''), to:{name: 'Folders - Ports Countries Ports Options Contacts'}})
      }
      if(this.$route.path.indexOf('options/contact') >= 0 && this.$route.path.indexOf('files') >= 0) {
        let detail = JSON.parse(this.$route.params.detailContact)
        links.push({name: detail.name + (''+this.$route.params.is_archive_files == 'true' ? ' Archive' : ''), to: {name: 'Folders - Ports Countries Ports Options Contact Files'}})
      }

      if(this.$route.path.indexOf('counterparties') >= 0) {
        links.push({name: 'Counterparties' + (''+this.$route.params.is_archive_counterparties == 'true' ? ' Archive' : ''), to: {name: 'Folders - Counterparties'}})
      }
      if(this.$route.path.indexOf('options') >= 0 && this.$route.path.indexOf('counterparties') >= 0) {
        let detail = JSON.parse(this.$route.params.detailCounterparties)
        links.push({name: detail.name + (''+this.$route.params.is_archive_counterparties == 'true' ? ' Archive' : ''), to: {name: 'Folders - Counterparties Options'}})
      }
      if(this.$route.path.indexOf('options/detail') >= 0 && this.$route.path.indexOf('counterparties') >= 0) {
        links.push({name: 'Details' + (''+this.$route.params.is_archive_files == 'true' ? ' Archive' : ''), to: {name: 'Folders - Counterparties Options Detail'}})
      }
      if(this.$route.path.indexOf('counterparties') >= 0 && this.$route.path.indexOf('payment') >= 0) {
        links.push({name: 'Payments' + (''+this.$route.params.is_archive_payments == 'true' ? ' Archive' : ''), to: {name: 'Folders - Counterparties Options Payment'}})
      }
      if(this.$route.path.indexOf('options/payments') >= 0 && this.$route.path.indexOf('counterparties') >= 0 && this.$route.path.indexOf('files') >= 0) {
        let detail = JSON.parse(this.$route.params.detailData)
        links.push({name: detail.date + (''+this.$route.params.is_archive_files == 'true' ? ' Archive' : ''), to: {name: 'Folders - Counterparties Options Payment Detail'}})
      }
      // let navigationPath = `<router-link class="fz20 fw500 text-dark" :to="{name: 'Folders - My files'}">My Files</router-link>`
      let path = this.$route.params.path
      console.log('path', path)
      let array = []
      if(path && path !== 'archive') {
        path = JSON.parse(path)
        path.forEach(item=> {
          array.push(item)
          if(this.$route.path.indexOf('my-files') >= 0) {
            if(this.$route.path.indexOf('archive') >= 0) {
              links.push({to: {name: 'Folders - My files Folder Archive', params: {path: JSON.stringify(array)}}, name: item.name + ' Archive'})
            } else {
              links.push({to: {name: 'Folders - My files Folder', params: {path: JSON.stringify(array)}}, name: item.name})
            }
          }
          if(this.$route.path.indexOf('a-payment')>=0) {
            if(this.$route.path.indexOf('archive')>=0) {
              links.push({to: {name: 'Folders - Payments Archive Folders Path Archive', params: {path: JSON.stringify(array)}, detailData: this.$route.params.detailData}, name: item.name + ' Archive'})
            } else {
              links.push({to: {name: 'Folders - Payments Folders Path Archive', params: {path: JSON.stringify(array), detailData: this.$route.params.detailData}}, name: item.name})
            }
          } else if(this.$route.path.indexOf('payment') >= 0) {
            if(this.$route.path.indexOf('archive')>=0) {
              links.push({to: {name: 'Folders - Simple payment and archive folders - path', params: {path: JSON.stringify(array)}, detailData: this.$route.params.detailData}, name: item.name + ' Archive'})
            } else {
              links.push({to: {name: 'Folders - Payments Folders Path', params: {path: JSON.stringify(array), detailData: this.$route.params.detailData}}, name: item.name})
            }
          } else if(this.$route.path.indexOf('tasks-a') >= 0) {
            if(this.$route.path.indexOf('archive')>=0) {
              links.push({to: {name: 'Folders - Tasks Archive Vessel Files Archive Path', params: {path: JSON.stringify(array)}, detailData: this.$route.params.detailData}, name: item.name + ' Archive'})
            } else {
              links.push({to: {name: 'Folders - Tasks Archive Vessel Files Path', params: {path: JSON.stringify(array), detailData: this.$route.params.detailData}}, name: item.name})
            }
          } else if(this.$route.path.indexOf('tasks') >= 0) {
            if(this.$route.path.indexOf('archive')>=0) {
              links.push({to: {name: 'Folders - Tasks Vessel Files Archive Path', params: {path: JSON.stringify(array)}, detailData: this.$route.params.detailData}, name: item.name + ' Archive'})
            } else {
              links.push({to: {name: 'Folders - Tasks Vessel Files Path', params: {path: JSON.stringify(array), detailData: this.$route.params.detailData}}, name: item.name})
            }
          } else if(this.$route.path.indexOf('shared-with-me') >= 0) {
            if(this.$route.path.indexOf('archive')>=0) {
              links.push({to: {name: 'Folders - Shared with me Folder Archive', params: {path: JSON.stringify(array)}}, name: item.name + ' Archive'})
            } else{
              links.push({to: {name: 'Folders - Shared with me Folder', params: {path: JSON.stringify(array)}}, name: item.name})
            }
          }
          if(this.$route.path.indexOf('option/cash-flow') >= 0 && this.$route.params.detailData && this.$route.params.path) {
            links.push({to: {name: 'Folders - Vessels Option CashFlow Files Path', params: {path: JSON.stringify(array)}}, name: item.name})
          }
          if(this.$route.path.indexOf('option/acc-invoice') >= 0 && this.$route.params.detailData && this.$route.params.path) {
            links.push({to: {name: 'Folders - Vessels Option Acc Invoice Files Path', params: {path: JSON.stringify(array)}}, name: item.name})
          }
          if(this.$route.path.indexOf('vessel-detail') >= 0) {
            links.push({to: {name: 'Folders - Vessels Option Vessel Detail Path', params: {path: JSON.stringify(array)}}, name: item.name})
          }
          if(this.$route.path.indexOf('option/charterers') >= 0 && this.$route.params.charterersDetail) {
            links.push({to: {name: 'Folders - Vessels Option Charterers Files Path', params: {path: JSON.stringify(array)}}, name: item.name})
          }
          if(this.$route.path.indexOf('options') >= 0 && this.$route.path.indexOf('countries') >= 0) {
            links.push({to: {name: 'Folders - Ports Countries Ports Options Details Path', params: {path: JSON.stringify(array)}}, name: item.name})
          }
          if(this.$route.path.indexOf('options/detail') >= 0 && this.$route.path.indexOf('counterparties') >= 0) {
            links.push({to: {name: 'Folders - Counterparties Options Detail Path', params: {path: JSON.stringify(array)}}, name: item.name})
          }
          // if(this.$route.path.indexOf('options/payments') >= 0 && this.$route.path.indexOf('counterparties') >= 0 && this.$route.path.indexOf('files') >= 0) {
          //   links.push({to: {name: 'Folders - Counterparties Options Payment Detail Path', params: {path: JSON.stringify(array)}}, name: item.name})
          // }
            // navigationPath += ''
          // navigationPath += `<!--<router-link class="fz20 f fw500 text-dark" :to="{name: 'Folders - My files Folder', params: {path: ${JSON.stringify(array).replaceAll('"', `'`)}}">${item.name}</router-link>-->`
        })
      }
      return links
    }
  },
  data() {
    return {
      deleteForeverModalShow: false,
      routeChange: -3827943,
      showArchiveModal: false,
      showModalCreateFolder: false,
      sort: this.$route.path.indexOf('folders/payments') == -1 && this.$route.name !== 'Folders - Counterparties Options Payment' && this.$route.name !== 'Folders - Vessels Option CashFlow' && this.$route.name !== 'Folders - Vessels Option Acc Invoice' ? this.$route.name === 'Folders - Vessels Option Charterers' ? 'cp_date' : 'name' : 'execute_date',
      search: '',
      disabledDownloadAll: false,
      prevRoute: '',
      loadMorePaymentBool: false,
      isOpenLeft: true,
      portsTotalPage: 0,
      portsCurrentPage: 1,
      loadingNextPageCountries: false,
      nameSection: '',
      loadMoreClientBool: false,
      nextLinkClientLeftList: false,
    }
  },
  watch: {
    // selectedFiles: function () {
    //   this.selected = this.selectedFiles.concat(this.selectedFolders)
    // },
    // selectedFolders: function () {
    //   this.selected = this.selectedFiles.concat(this.selectedFolders)
    // },
    emitSetCurrentFoldersInLeftMenuActualObject: function () {
      if(this.getActiveFolder) {
        // console.log('emitSetCurrentFoldersInLeftMenuActualObject folder')
        let event = new Event('changeList'+this.getActiveFolder)
        document.dispatchEvent(event)
      } else if(this.getActiveObject) {
        console.log('emitSetCurrentFoldersInLeftMenuActualObject object')
        let event = new Event('changeList'+this.getActiveObject)
        document.dispatchEvent(event)
      }
    },
    sort: function () {
      if(this.$route.path.indexOf('folders/payments') == -1 && this.$route.name !== 'Folders - Tasks' && this.$route.name !== 'Folders - Tasks Archive') {
        this.loadFiles()
      }
    },
    search: function () {
      if(this.$route.path.indexOf('folders/payments') == -1 && this.$route.name !== 'Folders - Tasks' && this.$route.name !== 'Folders - Tasks Archive') {
        this.setSearchForFolders(this.search)
        this.loadFiles()
      }
    },
    $route(to, from) {
      this.search = ''
      console.log()
      this.sort = this.$route.path.indexOf('folders/payments') == -1 && this.$route.name !== 'Folders - Counterparties Options Payment' && this.$route.name !== 'Folders - Vessels Option CashFlow' && this.$route.name !== 'Folders - Vessels Option Acc Invoice' ? this.$route.name === 'Folders - Vessels Option Charterers' ? 'cp_date' : 'name' : 'execute_date';
      this.clearSelectedFoldersPage()
      if(this.$route.name !== 'Folders - Payments') {
        // console.log('routs', (to.name !== from.name), !this.$route.params.path, this.$route.path.indexOf('my-files') >= 0)
        // if((to.name !== from.name) && !this.$route.params.path && this.$route.path.indexOf('my-files') >= 0) {
        //   this.loadFilesForList()
        // }
        this.loadFiles()
      }
      this.nameSection = this.getNameSection(to)
      setTimeout(()=> {
        this.routeChange++;
      }, 200)
      this.createEmitGetActivityFolders()
      this.checkChangeLinkBetweenNormalAndArchive(from, to)
    },
    nameSectionFolders: function () {
      this.isOpenLeft = true
      console.log('this.nameSectionFolders', this.nameSectionFolders)
      this.setFoldersList([])
      switch(this.nameSectionFolders) {
        case 'My Files':
          this.loadFilesForList()
          break;
        case 'Shared with me': {
          this.loadFilesForList()
          break;
        }
        case 'Payments': {
          this.loadPaymentFolderList()
          break;
        }
        case 'Tasks': {
          this.loadTasksFolderList()
          break;
        }
        case 'Vessels':
          this.loadVesselsFolderList()
              break;
        case 'Ports':
          this.loadPortsFolderList()
          break;
        case 'Counterparties':
          this.loadCounterpartiesFolderList()
          break;
      }
    }

  },
  methods: {
    ...mapActions(['axiosGetMoreCounterparties', 'axiosGetFoldersForCounterparty', 'axiosGetCountriesForFolders', 'axiosGetFoldersForPort', 'axiosGetFtpDownload', 'axiosGetFoldersForSOA', 'axiosGetShortViewVessels', 'axiosGetFoldersVorVessel', 'axiosGetFoldersForTasks', 'axiosUploadFolderInFolder', 'axiosGetFolderPayments', 'axiosGetClientsForFolder', 'axiosFoldersGetPaymentLoadMoreLeftList', 'axiosGetFoldersForPaymentDetail', 'axiosGetIdsSectionsForFolders', 'axiosDownloadFolder', 'axiosGetFolders', 'axiosCreateFileInFolder', 'axiosGetAllUsersForFolders', 'axiosGetFileById']),
    ...mapMutations(['pushFoldersList', 'addTip', 'emitChangeLeftMenuSetCurrentFoldersInActiveObject', 'createEmitGetActivityFolders', 'addedFolderInMoveToModal', 'setFoldersList', 'setFoldersForMoveTo', 'showModalOpenAccessBoolMeth', 'showLoad', 'hideLoad', 'setSearchForFolders', 'setListViewFoldersPage', 'clearSelectedFoldersPage', 'showModalOpenAccess']),
    clickArrow(e, bool) {
      if(bool) {
        e.preventDefault()
        this.isOpenLeft = !this.isOpenLeft
      }
    },
    getNameSection(linkTo = this.$route) {
      console.log('linkTo', linkTo)
      let path = linkTo.params.path ? linkTo.params.path : null
      if(path) {
        path = JSON.parse(path)
        return path[path.length - 1].name
      }
      let name = ''
      if(linkTo.path.indexOf('my-files') >= 0) {
        name = 'My Files'
      }
      if(linkTo.path.indexOf('shared-with-me') >= 0) {
        name = 'Shared with me'
      }
      if(linkTo.path.indexOf('payments')>= 0) {
        name = 'Payments'
      }
      if(linkTo.path.indexOf('important') >= 0) {
        name = 'Important'
      }
      if(linkTo.path.indexOf('payment') >= 0) {
        name = linkTo.params.detailData ? JSON.parse(linkTo.params.detailData).date : 'Payment'
      }
      if(linkTo.path.indexOf('tasks')>= 0) {
        name = linkTo.params.detailData ? JSON.parse(linkTo.params.detailData).name : 'Tasks'

      }
      if(linkTo.path.indexOf('tasks-a')>= 0) {
        name = linkTo.params.detailData ? JSON.parse(linkTo.params.detailData).name : 'Tasks Archive'
      }
      if(linkTo.name == 'Folders - Vessels Options') {
        let detail = JSON.parse(linkTo.params.detailVessel)
        name = detail.name + ' ' + detail.cp_date + (''+linkTo.params.vessels_is_archive == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Vessels') {
        name ='Vessels' + (''+linkTo.params.vessels_is_archive == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Vessels Option CashFlow') {
        name = 'Cash Flow' + (''+linkTo.params.cash_flow_is_archive == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Vessels Option CashFlow Files' || linkTo.name == 'Folders - Vessels Option Acc Invoice File') {
        let detail = JSON.parse(linkTo.params.detailData)
        name = detail.date ? detail.date : 'Payment' + (''+linkTo.params.files_is_archive == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Vessels Option Vessel Detail') {
        name = 'Vsl Details' + (''+linkTo.params.files_is_archive == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Vessels Option Owners') {
        name = 'Owners' + (''+linkTo.params.owners_is_archive == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Vessels Option Charterers') {
        name = 'Charterers'
      }
      if(linkTo.name == 'Folders - Vessels Option Charterers Files') {
        let detail = JSON.parse(linkTo.params.charterersDetail)
        name = (detail.type !== 'sublet' ? 'Voyage' : 'Sublet') + (detail.cp_date ? '/'+detail.cp_date : '') + (detail.owner_name ? '/'+detail.owner_name : '') + (linkTo.params.files_is_archive == true ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Vessels Option Acc Invoice') {
        name = 'Acc. Invoices' + (''+linkTo.params.cash_flow_is_archive == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Ports') {
        return 'Countries' + (linkTo.params.countries_is_archive == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Ports Countries Ports') {
        return 'Ports'
      }
      if(linkTo.name == 'Folders - Ports Countries Ports Options') {
        let detail = JSON.parse(linkTo.params.portDetail)
        return detail.name
      }
      if(linkTo.name == 'Folders - Ports Countries Ports Options Details') {
        return 'Details' + (linkTo.params.is_archive_files == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Ports Countries Ports Options Berth List') {
        return 'Berth List'+ (''+linkTo.params.is_archive_berth_list == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Ports Countries Ports Options Berth List Detail') {
        let detail = JSON.parse(linkTo.params.detailList)
        return detail.name + (''+linkTo.params.is_archive_files == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Ports Countries Ports Options Contacts') {
        return 'Contacts' + (''+linkTo.params.is_archive_contacts == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Ports Countries Ports Options Contact Files') {
        let detail = JSON.parse(linkTo.params.detailContact)
        return detail.name + (''+linkTo.params.is_archive_files == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Counterparties') {
        return 'Counterparties' + (linkTo.params.is_archive_counterparties == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Counterparties Options') {
        let detail = JSON.parse(linkTo.params.detailCounterparties)
        return detail.name + (''+linkTo.params.is_archive_counterparties == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Counterparties Options Detail') {
        return 'Details' + (linkTo.params.is_archive_files == 'true' ? ' Archive' : '' )
      }
      if(linkTo.name == 'Folders - Counterparties Options Payment') {
        return 'Payments' + (linkTo.params.is_archive_payments == 'true' ? ' Archive' : '' )
      }
      return name + (linkTo.path.indexOf('archive') >= 0 ? ' Archive' : '')
    },

    async loadPortsFolderList() {
      this.portsCurrentPage = 1
      let res = await this.axiosGetCountriesForFolders({params: {page: this.portsCurrentPage, ordering: 'country', limit: 20, is_archive: this.$route.params.countries_is_archive}})
      console.log('axiosGetCountriesForFolders', res)
      res.ports.forEach(item=> {
        item['folders'] = []
        item['hide_svg'] = true
        item['type_load'] = 'country'
        item['type_object'] = 'country'
        item['is_show'] = false
        item['is_load'] = false
        item['created_in'] = false
      })
      this.setFoldersList(res.ports)
      this.portsCurrentPage = res.current_page
      this.portsTotalPage = res.total_page
    },

    async loadNextCountries() {
      this.loadingNextPageCountries = true
      this.portsCurrentPage++
      let res = await this.axiosGetCountriesForFolders({params: {page: this.portsCurrentPage, ordering: 'country', limit: 20, is_archive: this.$route.params.countries_is_archive}})
      res.ports.forEach(item=> {
        item['folders'] = []
        item['hide_svg'] = true
        item['type_load'] = 'country'
        item['type_object'] = 'country'
        item['is_show'] = false
        item['is_load'] = false
        item['created_in'] = false
      })
      this.pushFoldersList(res.ports)
      this.portsCurrentPage = res.current_page
      this.portsTotalPage = res.total_page
      this.loadingNextPageCountries = false
    },
    checkChangeLinkBetweenNormalAndArchive(linkFrom, linkTo) {
      console.log('checkChangeLinkBetweenNormalAndArchive', linkFrom, linkTo)
      let isArchivePageLinkFrom = linkFrom ? linkFrom.path.indexOf('archive') >= 0 : null
      let isArchivePageLinkTo = linkTo ? linkTo.path.indexOf('archive') >= 0 : null
      if(isArchivePageLinkTo !== isArchivePageLinkFrom) {
        this.clickArchiveLink()

      }
    },
    clickArchiveLink() {
      setTimeout(()=> {
        this.isOpenLeft = true
        console.log('this.nameSectionFolders', this.nameSectionFolders)
        switch(this.nameSectionFolders) {
          case 'My Files':
            this.loadFilesForList()
            break;
          case 'Shared with me':
            this.loadFilesForList()
            break;
          case 'Payments':
            this.loadPaymentFolderList()
            break;
          case 'Tasks':
            this.loadTasksFolderList()
            break;
          case 'Vessels':
            this.loadVesselsFolderList()
            break;
          case 'Ports':
            this.loadPortsFolderList()
            break;
          case 'Counterparties':
            this.loadCounterpartiesFolderList()
            break;
        }
      }, 200)
    },
    loadTasksFolderList() {
      let array = [
        {
          link: '',
          folders: [],
          hide_svg: true,
          type_load: 'pre_tasks',
          type_object: 'pre_tasks',
          is_show: false,
          is_load: false,
          create_in: false,
          name: 'Manually Tasks'
        },
        {
          link: '',
          folders: [],
          hide_svg: true,
          type_load: 'pre_tasks',
          type_object: 'pre_tasks',
          is_show: false,
          is_load: false,
          create_in: false,
          name: 'Vessel Search'
        },
        {
          link: '',
          folders: [],
          hide_svg: true,
          type_load: 'pre_tasks',
          type_object: 'pre_tasks',
          is_show: false,
          is_load: false,
          create_in: false,
          name: 'Cargo Search'
        }
      ]
      this.setFoldersList(array)

    },
    async loadVesselsFolderList() {
      // let res = await this.axiosGetShortViewVessels({search: '', is_redelivery: false, ordering: 'name', limit: 20})
      // let contracts = []
      // contracts = res.data.results.map(item=> {
      //   item['link'] = ''
      //   item['folders'] = []
      //   item['hide_svg'] = true
      //   item['type_load'] = 'payment'
      //   item['type_object'] = 'payment'
      //   item['is_show'] = false
      //   item['is_load'] = false
      //   item['created_in'] = false
      //   return item
      // })
      // this.setFoldersList(JSON.parse(JSON.stringify(contracts)))
      let array = [
        {
          link: '',
          folders: [],
          hide_svg: true,
          type_load: 'actual_vessel',
          type_object: 'actual_vessel',
          is_show: false,
          is_load: false,
          create_in: false,
          name: 'Actual Vessel'
        },
        {
          link: '',
          folders: [],
          hide_svg: true,
          type_load: 'redelivered_vessel',
          type_object: 'redelivered_vessel',
          is_show: false,
          is_load: false,
          create_in: false,
          name: 'Redelivered Vessel'
        },
      ]
      this.setFoldersList(array)

    },
    async loadPaymentFolderList() {
      let form = {
        type: 'payment',
        is_archived: this.$route.path.indexOf('archive') >= 0,
        limit: 25,
        ordering: 'execute_date,id',
        stopCancel: true,
        left_menu: true,
      }
      let payments = await this.axiosGetFolderPayments(form)
      payments.forEach(item=> {
        item['link'] = {name: 'Folders - Payments Folders', params: {detailData: JSON.stringify({id: item.id, date: item.execute_date ? ''+moment(item.execute_date).format('DD.MM.YYYY') : 'Payment'})}}
        item['folders'] = []
        item['hide_svg'] = true
        item['type_load'] = 'payment'
        item['type_object'] = 'payment'
        item['is_show'] = false
        item['is_load'] = false
        item['created_in'] = false
        item['name'] = item.execute_date ? moment(item.execute_date).format('DD.MM.YYYY') : 'Payment'
      })
      console.log(payments)
      console.log('setFoldersList', payments)
      this.setFoldersList(JSON.parse(JSON.stringify(payments)))
    },
    async loadCounterpartiesFolderList() {
      let form = {
        ordering: 'company_name',
        is_archived: this.$route.params.is_archive_counterparties,
        limit: 20
      }
      let res = await this.axiosGetClientsForFolder({params: form})
      console.log('counterparties', res)
      res.results.forEach(item=> {
        item['link'] = ''
        item['folders'] = []
        item['hide_svg'] = true
        item['type_load'] = 'counterparties'
        item['type_object'] = 'counterparties'
        item['is_show'] = false
        item['is_load'] = false
        item['created_in'] = false
        item['name'] = item.company_name
      })
      this.setFoldersList(JSON.parse(JSON.stringify(res.results)))
      this.nextLinkClientLeftList = res.next
    },
    async loadMoreClient() {
      this.loadMoreClientBool = true
      let res = await this.axiosGetMoreCounterparties(this.nextLinkClientLeftList)
      console.log('counterparties', res)
      res.results.forEach(item=> {
        item['link'] = ''
        item['folders'] = []
        item['hide_svg'] = true
        item['type_load'] = 'counterparties'
        item['type_object'] = 'counterparties'
        item['is_show'] = false
        item['is_load'] = false
        item['created_in'] = false
        item['name'] = item.company_name
      })
      this.setFoldersList(JSON.parse(JSON.stringify(this.foldersList.concat(res.results))))
      this.nextLinkClientLeftList = res.next
      this.loadMoreClientBool = false
    },
    async loadMorePayment() {
      this.loadMorePaymentBool = true
      await this.axiosFoldersGetPaymentLoadMoreLeftList()
      this.loadMorePaymentBool = false
    },
    linkTo(data) {
      console.log('linkTo', data)
      let params = {}
      if(Array.isArray(data.link) === true && data.link.length !== 0) {
        params['path'] = JSON.stringify(data.link)
      }
      if(data.ownersDetail) {
        params['ownersDetail'] = JSON.stringify(data.ownersDetail)
      }
      if(data.detailData) {
        params['detailData'] = JSON.stringify(data.detailData)
      }
      if(data.charterers_is_archive !== null && data.charterers_is_archive !== undefined) {
        params['charterers_is_archive'] = data.charterers_is_archive
      }
      if(data.files_is_archive !== null && data.files_is_archive !== undefined) {
        params['files_is_archive'] = data.files_is_archive
      }
      if(data.owners_is_archive !== null && data.owners_is_archive !== undefined) {
        params['owners_is_archive'] = data.owners_is_archive
      }
      if(data.vessels_is_archive !== null && data.vessels_is_archive !== undefined) {
        params['vessels_is_archive'] = data.vessels_is_archive
      }
      if(data.cash_flow_is_archive !== null && data.cash_flow_is_archive !== undefined) {
        params['cash_flow_is_archive'] = data.cash_flow_is_archive
      }
      if(data.detailVessel) {
        params['detailVessel'] = JSON.stringify(data.detailVessel)
      }
      if(data.charterersDetail) {
        params['charterersDetail'] = JSON.stringify(data.charterersDetail)
      }
      if(data.countryDetail) {
        params['countryDetail'] = JSON.stringify(data.countryDetail)
        console.log('params[\'countryDetail\']', params['countryDetail'])
      }
      if(data.countries_is_archive !== null && data.countries_is_archive !== undefined) {
        params['countries_is_archive'] = data.countries_is_archive
      }
      if(data.is_archive_berth_list !== null && data.is_archive_berth_list !== undefined) {
        params['is_archive_berth_list'] = data.is_archive_berth_list
      }

      if(data.portDetail) {
        params['portDetail'] = JSON.stringify(data.portDetail)
      }
      if(data.is_archive_files !== null && data.is_archive_files !== undefined) {
        params['is_archive_files'] = data.is_archive_files
      }
      if(data.port_berth_list !== null && data.port_berth_list !== undefined) {
        params['port_berth_list'] = data.port_berth_list
      }
      if(data.detailList) {
        params['detailList'] = JSON.stringify(data.detailList)
      }
      if(data.is_archive_contacts !== null && data.is_archive_contacts !== undefined) {
        params['is_archive_contacts'] = data.is_archive_contacts
      }
      if(data.detailContact) {
        params['detailList'] = JSON.stringify(data.detailContact)
      }
      if(data.detailCounterparties) {
        params['detailCounterparties'] = JSON.stringify(data.detailCounterparties)
      }
      if(data.is_archive_payments) {
        params['is_archive_payments'] = data.is_archive_payments
      }
      if(data.is_archive_counterparties) {
        params['is_archive_counterparties'] = data.is_archive_counterparties
      }
      console.log(data)
      console.log(params)
      this.$router.push({name: data.name,params:params})
    },

    unarchiveSelected() {
      this.setFoldersForMoveTo([this.selected])
    },
    async loadFilesForList() {
      if(!this.listSectionsIds.length) {
        await this.axiosGetIdsSectionsForFolders();
      }
     let res = await this.axiosGetFileById(this.getParentIdSection)
     console.log(res)
      res = res.filter(a=> a.is_archive == this.$route.path.indexOf('archive') >= 0)
     res.forEach(item=> {
       item['folders'] = []
       item['is_load'] = false
       item['is_show'] = false
     })
      console.log('setFoldersList', res)
      res = res.filter(a=> a.is_archive == this.$route.path.indexOf('archive') >= 0)
     this.setFoldersList(res)
     // this.foldersList = res
   },
    async loadFiles() {
      this.showLoad()
     if(this.$route.params.path) {
       let path = JSON.parse(this.$route.params.path)
       let params ={is_archive: this.$route.path.indexOf('archive') >= 0, ordering: '-is_important,'+this.sort, search: this.search}
       // if(this.$route.path.indexOf('shared-with-me') >= 0 && ) {
       //   params['shared_for_me'] = true
       // } else {
         params['parent_file'] = path[path.length-1].id
       // }
       await this.axiosGetFolders(params)
     } else {
       let params ={is_archive: this.$route.path.indexOf('archive') >= 0, ordering: '-is_important,'+this.sort, search: this.search}
       if(this.$route.path.indexOf('shared-with-me') >= 0) {
         params['shared_for_me'] = true
       } else {
         params['parent_file'] = this.getParentIdSection
       }
       if(this.$route.path.indexOf('payment/') >= 0 || this.$route.path.indexOf('cash-flow') >= 0 || this.$route.path.indexOf('acc-invoice')>=0 || (this.$route.path.indexOf('payments/') >= 0)) {
         await this.axiosGetFoldersForPaymentDetail({id: this.$route.params.detailData ? JSON.parse(this.$route.params.detailData).id : null, is_archive_files: (this.$route.path.indexOf('archive') >= 0 || ''+this.$route.params.files_is_archive == 'true' || ''+this.$route.params.is_archive_files == 'true'), search: this.search})
       } else if(this.$route.path.indexOf('tasks/') >= 0 || this.$route.path.indexOf('tasks-a/') >= 0) {
         await this.axiosGetFoldersForTasks({id: this.$route.params.detailData ? JSON.parse(this.$route.params.detailData).id : null, params:{ is_archive_files: this.$route.path.indexOf('archive') >= 0, ordering: this.sort, search: this.search}})
       } else if(this.$route.path.indexOf('vessel-detail') >= 0) {
         await this.axiosGetFoldersVorVessel({id: this.$route.params.detailVessel ? JSON.parse(this.$route.params.detailVessel).id : null, params: {is_archive_files: this.$route.params.files_is_archive,ordering: this.sort, search: this.search}})
       } else if(this.$route.path.indexOf('option/owners') >= 0) {
         await this.axiosGetFoldersForSOA({is_archive_files: this.$route.params.owners_is_archive, ordering: this.sort, search: this.search, contract: this.$route.params.detailVessel ? JSON.parse(this.$route.params.detailVessel).id : null, limit: 1, folders: true})
       } else if(this.$route.path.indexOf('options/details') >= 0 && this.$route.path.indexOf('port') >= 0) {
         await this.axiosGetFoldersForPort({typeFile: true, type: 'files', id: this.$route.params.portDetail ? JSON.parse(this.$route.params.portDetail).id : null ,params: {is_archive_files: this.$route.params.is_archive_files, search: this.search}})
       } else if(this.$route.path.indexOf('options/berth-list') >= 0 && this.$route.path.indexOf('detail') >= 0) {
         await this.axiosGetFoldersForPort({typeFile: true, type: 'berths', findId: JSON.parse(this.$route.params.detailList).id, id: this.$route.params.portDetail ? JSON.parse(this.$route.params.portDetail).id : null ,params: {is_archive_files: this.$route.params.is_archive_files, search: this.search}})
       } if(this.$route.path.indexOf('options/contact') >= 0 && this.$route.path.indexOf('files') >= 0) {
         await this.axiosGetFoldersForPort({typeFile: true, type: 'contacts', findId: JSON.parse(this.$route.params.detailContact).id, id: this.$route.params.portDetail ? JSON.parse(this.$route.params.portDetail).id : null ,params: {is_archive_files: this.$route.params.is_archive_files, search: this.search}})
       } else if(this.$route.path.indexOf('counterparties') >= 0 && this.$route.path.indexOf('/options/detail') >= 0) {
         await this.axiosGetFoldersForCounterparty({id: JSON.parse(this.$route.params.detailCounterparties).id,params: {is_archive_files: this.$route.params.is_archive_files, ordering: this.sort, search: this.search}})
       } else if((this.getParentIdSection || this.$route.path.indexOf('shared-with-me') >= 0) && ['Folders - Ports Countries Ports Options Berth List Detail', 'Folders - Vessels Option Charterers Files', 'Folders - Vessels Option Charterers', 'Folders - Ports Countries Ports Options Contact Files'].indexOf(this.$route.name) == -1) {
         await this.axiosGetFolders(params)
       }
     }
      this.emitChangeLeftMenuSetCurrentFoldersInActiveObject()

      this.hideLoad()
   },
    async downloadAll() {
      if(this.selected.length == 1) {
        this.downloadFile(this.selected[0])
        return null;
      }
      let id = [];
      this.selected.map(a=> {
        id.push(a.id)
      })
      this.disabledDownloadAll = true;
      let response = await this.axiosGetFtpDownload(id);
      if(response !== null) {
        console.log('zip', response)
        JSZip.loadAsync(response.data).then(res=> {
          res.generateAsync({type: "blob"})
              .then((content) => {
                let link1 = document.createElement("a");
                link1.href = window.URL.createObjectURL(content);
                link1.download = 'My Files';
                link1.click();
                this.disabledDownloadAll = false;

              }).catch(()=> {
            this.disabledDownloadAll = false;
          });
        }).catch( ()=> {
          this.disabledDownloadAll = false;
        })
      } else {
        this.disabledDownloadAll = false;
        this.addTip("There are no files to download")
      }
      // let content = JSZip.folder(response.data, 'zip')

    },
    async downloadFile (file) {
      if(file.file_type === 'FOLDER') {
        let id = [];
        id.push(file.id)
        let response = await this.axiosGetFtpDownload([id])

        JSZip.loadAsync(response.data).then(res=> {

          res.generateAsync({type:"blob"})
              .then(function(content) {
                // see FileSaver.js
                // (content, "example.zip");
                console.log(content)
                let link1 = document.createElement("a");
                link1.href = window.URL.createObjectURL(content);
                link1.download = file.name;
                link1.click();
              });
        })


        // this.download( response.data, 'application/zip', file.name)
      } else {
        console.log(file)
        axios.get(this.getUrlLink(file.url), { responseType: 'blob' })
            .then(response => {
              console.log(response)
              const blob = new Blob([response.data], { type: 'application/plain' })
              const link = document.createElement('a')
              link.href = URL.createObjectURL(blob)
              link.download = file.name;
              link.click()
              URL.revokeObjectURL(link.href)
            }).catch(console.error)
      }

    },
    getUrlLink(link) {
      if(link && link.indexOf(process.env.VUE_APP_URL_SIMPLE)>=0) {
        return link;
      }
      return this.getURL()+ link
    },
    getURL() {
      return process.env.VUE_APP_URL_SIMPLE
    },
    async uploadFile(e) {
      // this.showLoad()
      console.log('files', e.target.files)
      // if(e.target.files.length > 1) {
      //   this.uploadFolder(e, true)
      //   return null
      // }
      let files = e.target.files
      // let filesForm = {}
      let formData = new FormData();

          for(let i=0; i<files.length; i++) {
            let file = files[i]
            if(files.length > 1) {
              formData.append("files", file);
            } else {
              formData.append("file", file);
            }
            formData.append("file_type", 'FILE');
            formData.append("type", this.getTypeFileBySection);
            if(files.length > 1) {
              formData.append("names", file.name);
            } else {
              formData.append("name", file.name);
            }
            let path = this.$route.params.path ? this.$route.params.path : null
            let parent_id = null
            if(path) {
              path = JSON.parse(path)
              parent_id = path[path.length -1].id
              formData.append("parent_file", parent_id);
            } else {
              if(this.$route.path.indexOf('payment')>=0 || this.$route.path.indexOf('cash-flow')>=0 || this.$route.path.indexOf('acc-invoice')>=0) {
                formData.append('destination', 'payments')
                let id = JSON.parse(this.$route.params.detailData).id
                formData.append('destination_object_id', id)
              } else if(this.$route.path.indexOf('tasks') >= 0) {
                formData.append('destination', 'tasks')
                let id = JSON.parse(this.$route.params.detailData).id
                formData.append('destination_object_id', id)
              } else if(this.$route.path.indexOf('vessel-detail') >= 0) {
                formData.append('destination', 'vessels')
                let id = JSON.parse(this.$route.params.detailVessel).id
                formData.append('destination_object_id', id)
              } else if(this.$route.path.indexOf('option/owners') >= 0) {
                formData.append('destination', 'owners')
                let id = JSON.parse(this.$route.params.ownersDetail).id
                formData.append('destination_object_id', id)
              } else if(this.$route.path.indexOf('options/details/') >= 0 && this.$route.path.indexOf('port') >= 0) {
                formData.append('destination', 'ports')
                let id = JSON.parse(this.$route.params.portDetail).id
                formData.append('destination_object_id', id)
              } else if(this.$route.path.indexOf('options/berth-list') >= 0) {
                formData.append('destination', 'ports_berth_list')
                let id = JSON.parse(this.$route.params.detailList).id
                formData.append('destination_object_id', id)
              } else if(this.$route.path.indexOf('options/contact') >= 0) {
                formData.append('destination', 'ports_contracts')
                let id = JSON.parse(this.$route.params.detailContact).id
                formData.append('destination_object_id', id)
              } else if(this.$route.path.indexOf('counterparties') >= 0 && this.$route.path.indexOf('options/detail') >= 0) {
                formData.append('destination', 'counterparties')
                let id = JSON.parse(this.$route.params.detailCounterparties).id
                formData.append('destination_object_id', id)
              } else {
                formData.append("parent_file", this.listSectionsIds.find(a=> a.name == "myfiles").id);
              }
            }
            formData.append("is_important", false);
            formData.append("is_archive", false);

            // formData.append("shared_with", );
            console.log('formData', ...formData.entries())
            if(files.length == 1) {
              await this.axiosCreateFileInFolder({data: formData})
              formData = new FormData();
            }
          }
      if(files.length>1) {
        let res = await this.axiosCreateFileInFolder({data: formData,})
        // this.hideLoad()
        if(res) {
          console.log(1)
        }
      }

      this.createEmitGetActivityFolders()
      this.loadFiles()
      e.target.value = ''
    },
    async uploadFolder(e, withoutPath) {
      let files = e.target.files
      let filteredFiles = []
      for(let i=0; i<files.length; i++) {
        if(files[i].name.indexOf('.DS') == -1 && files[i].name.indexOf('.ini') == -1) {
          filteredFiles.push(files[i])
        }
      }
      if(filteredFiles.length == 0) {
        e.target.value = ''
        this.addTip('You can\'t upload an empty folder')
        return null
      }
      let errorName = filteredFiles.find(a=> a.name == a.webkitRelativePath)
      errorName = errorName ? errorName.name : null
      if(errorName) {
        errorName = this.folders.find(a=> a.name == errorName)
        if(errorName) {
          e.target.value = ''
          this.addTip('Unable to upload. An object with the same name already exists')
          return null
        }
      }

      console.log('filteredFiles', filteredFiles)
      let formatUploadFolder = new FormData();

      let filesPaths = []
      for(let i=0; i<filteredFiles.length; i++) {
        let file = filteredFiles[i]
        filesPaths.push(''+file.webkitRelativePath)
        formatUploadFolder.append('files', file)
        formatUploadFolder.append('webkit_paths', withoutPath == true ? '' : ''+file.webkitRelativePath)
      }
      let path = this.$route.params.path ? this.$route.params.path : null
      let parent_id = null
      if(path) {
        path = JSON.parse(path)
        parent_id = path[path.length -1].id
        formatUploadFolder.append("parent_file", parent_id)
      }
      // else {
        if(this.$route.path.indexOf('payment')>=0 || this.$route.path.indexOf('cash-flow')>=0 || this.$route.path.indexOf('acc-invoice')>=0) {
          formatUploadFolder.append('destination', 'payments')
          let id = JSON.parse(this.$route.params.detailData).id
          formatUploadFolder.append('destination_object_id', id)
        } else if(this.$route.path.indexOf('tasks') >= 0) {
          formatUploadFolder.append('destination','tasks')
          let id = JSON.parse(this.$route.params.detailData).id
          formatUploadFolder.append('destination_object_id', id)
        } else if(this.$route.path.indexOf('vessel-detail') >= 0) {
          formatUploadFolder.append('destination', 'vessels')
          let id = JSON.parse(this.$route.params.detailVessel).id
          formatUploadFolder.append('destination_object_id', id)
        } else if(this.$route.path.indexOf('options/details/') >= 0 && this.$route.path.indexOf('port') >= 0) {
          formatUploadFolder.append('destination', 'ports')
          let id = JSON.parse(this.$route.params.portDetail).id
          formatUploadFolder.append('destination_object_id', id)
        }  else if(this.$route.path.indexOf('counterparties') >= 0 && this.$route.path.indexOf('options/detail') >= 0) {
          formatUploadFolder.append('destination', 'counterparties')
          let id = JSON.parse(this.$route.params.detailCounterparties).id
          formatUploadFolder.append('destination_object_id', id)
        }  else if(!path) {
          console.log(  1)
          formatUploadFolder.append("parent_file", this.listSectionsIds.find(a=> a.name == "myfiles").id)
        }
      // }

      console.log(formatUploadFolder)
      await this.axiosUploadFolderInFolder(formatUploadFolder)
      this.createEmitGetActivityFolders()
      this.loadFiles()
      e.target.value = ''
    },

    async createFolder(name) {
      if(name.length == 0) {
        return null
      }
      this.showModalCreateFolder = false
      this.showLoad()
      let formData = ''
      formData = {
        file_type: 'FOLDER',
        type: this.getTypeFileBySection,
        name: name,
        // path_to_folder: this.getPathToFolder,
        is_important: false,
        is_archive: false,
        shared_with: [],
      }
      console.log('getTypeFileBySection', this.getTypeFileBySection)
      let path = this.$route.params.path ? this.$route.params.path : null
      let parent_id = null
      if(path) {
        path = JSON.parse(path)
        parent_id = path[path.length -1].id
        formData["parent_file"] = parent_id
      } else {
        if(this.$route.path.indexOf('payment')>=0 || this.$route.path.indexOf('cash-flow')>=0 || this.$route.path.indexOf('acc-invoice')>=0) {
          formData['destination'] = 'payments'
          let id = JSON.parse(this.$route.params.detailData).id
          formData['destination_object_id'] = id
        } else if(this.$route.path.indexOf('tasks') >= 0) {
          formData['destination'] = 'tasks'
          let id = JSON.parse(this.$route.params.detailData).id
          formData['destination_object_id'] = id
        } else if(this.$route.path.indexOf('vessel-detail') >= 0) {
          formData['destination'] = 'vessels'
          let id = JSON.parse(this.$route.params.detailVessel).id
          formData['destination_object_id'] = id
        } else if(this.$route.path.indexOf('option/owners') >= 0) {
          formData['destination'] = 'invoices'
          let id = JSON.parse(this.$route.params.detailVessel).id
          formData['destination_object_id'] = id
        } if(this.$route.path.indexOf('options/details/') >= 0 && this.$route.path.indexOf('port') >= 0) {
          formData['destination'] = 'ports'
          let id = JSON.parse(this.$route.params.portDetail).id
          formData['destination_object_id'] = id
        } else if(this.$route.path.indexOf('counterparties') >= 0 && this.$route.path.indexOf('options/detail') >= 0) {
          formData['destination'] = 'counterparties'
          let id = JSON.parse(this.$route.params.detailCounterparties).id
          formData['destination_object_id'] = id
        } else {
          formData["parent_file"] = this.getParentIdSection
        }
      }

      let res = await this.axiosCreateFileInFolder({data: formData, params: {is_create: true}})
      formData.id = res.id
      formData.name = res.name
      // this.addedFolderInMoveToModal({activeFolder: path ? parent_id : this.getActiveObject ? this.getActiveObject : 'myfiles', item: formData})
      this.hideLoad()
      this.createEmitGetActivityFolders()
      if(res) {
        console.log(1)
      }
      this.loadFiles()
    },
    selectFile(item) {
      if(this.selectedFiles.map(a=> {return a.id}).indexOf(item.id) >= 0) {
        this.selectedFiles = this.selectedFiles.filter(a=> a.id !== item.id)
      } else {
        this.selectedFiles.push(item)
      }
    },
    selectFileAll() {
      if(this.selectedFiles.length !== this.files.length) {
        this.selectedFiles = JSON.parse(JSON.stringify(this.files))
      } else {
        this.selectedFiles = []
      }
    },
    selectFolder(item) {
      if(this.selectedFolders.map(a=> {return a.id}).indexOf(item.id) >= 0) {
        this.selectedFolders = this.selectedFolders.filter(a=> a.id !== item.id)
      } else {
        this.selectedFolders.push(item)
      }
    },
    selectFolderAll() {
      if(this.selectedFolders.length !== this.folders.length) {
        this.selectedFolders = JSON.parse(JSON.stringify(this.folders))
      } else {
        this.selectedFolders = []
      }
    }
  },
  async mounted() {
    await this.axiosGetIdsSectionsForFolders();
    // if(this.$route.path.indexOf('folders/payment') == -1) {
    //   if(!this.$route.params.parth && this.$route.path.indexOf('my-files') >= 0) {
    //     this.loadFilesForList()
    //   }
    // }

   this.loadFiles()
    this.axiosGetAllUsersForFolders()
  }
}
</script>

<style scoped lang="scss">
  .top-panel {
    box-shadow: inset 0px -1px 0px #BDCBD6;
  }
  .content {
    height: calc(100vh - 106px);
    background-color: var(--color-bgc-page);
  }
  .active {
    background-color: var(--color-blue-lightest);
    color: var(--color-blue-dark) !important;
    svg {
      path {
        fill: var(--color-blue-dark)
      }
    }
  }

.bottom-panel {
  box-shadow: 0px 1px 0px 0px #BDCBD6 inset;
  &>:nth-child(2) {
    margin-left: auto;
  }
}
.upload {
  position: absolute;
  opacity: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.wrap-page {
  width: calc(100vw - 288px - 274px);
}
</style>